import $ from 'jquery'
window.jQuery = $;
window.$ = $;
import '@popperjs/core/dist/umd/popper.min.js'
import 'vimeo-froogaloop2/javascript/froogaloop.min.js'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'galleria/dist/themes/classic/galleria.classic.css'
// import 'galleria/dist/themes/fullscreen/galleria.fullscreen.css'
// import 'galleria/dist/themes/azur/galleria.azur.css'
// import 'galleria/dist/themes/twelve/galleria.twelve.css'
// import 'galleria/dist/themes/miniml/galleria.miniml.css'
// import 'galleria/dist/themes/folio/galleria.folio.css'
import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// import * as dat from 'dat.gui'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import { CSS2DObject, CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
// import { gsap } from 'gsap'
import Stats from 'stats.js'
import galleria from 'galleria'
window.Galleria = galleria;  // webpack

import indexCsv from './indexList.csv'


import "@fontsource/noto-sans-kr"; 

//https://obfuscator.io/
// import * as THREE from 'https://unpkg.com/three@0.119.1/build/three.module.js';
// import { OrbitControls } from 'https://unpkg.com/three@0.119.1/examples/jsm/controls/OrbitControls.js';
//import { OrbitControls } from './jsm/controls/OrbitControls.js';
// import { GLTFLoader } from 'https://unpkg.com/three@0.119.1/examples/jsm/loaders/GLTFLoader.js';
// import { RGBELoader } from 'https://unpkg.com/three@0.119.1/examples/jsm/loaders/RGBELoader.js';
// import { CSS2DObject, CSS2DRenderer } from 'https://unpkg.com/three@0.119.1/examples/jsm/renderers/CSS2DRenderer.js';
//import {OBJLoader2} from 'https://unpkg.com/three@0.119.1/examples/jsm/loaders/OBJLoader2.js';
//import {MTLLoader} from 'https://unpkg.com/three@0.119.1/examples/jsm/loaders/MTLLoader.js';
//import {MtlObjBridge} from 'https://unpkg.com/three@0.119.1/examples/jsm/loaders/obj2/bridge/MtlObjBridge.js';
// import Stats from 'https://cdnjs.cloudflare.com/ajax/libs/stats.js/r17/Stats.min.js';

//Screen Saver
var isScreenSaverMode = false;
var screenSaverCamera;
var currentRenderCamera;
var planetRotationXOffset = 0.0;
var prevCenterOfRotation = new THREE.Vector3( 0, 0, 0 );
var centerOfRotation = new THREE.Vector3( 0, 0, 0 );
var targetCenterOfRotation = new THREE.Vector3( 0, 0, 0 );
var cameraRotationSpeed = 1.0;
var screenSaverStartTime = 0.0;
var screenSaverCameraDistance = 0.0;
var screenSaverCameraAngle;
var screenSaverTimeOffset = 0;
var screenSaverTargetZOffset = -0.015;
var readyForScreenSaver = false;
var lastInteractionTime = performance.now();
var screenSaverWaitTime = 90 * 1000; // 90 * 1000
var startCameraDistance;

var isMobile = false;
var debugStartSphere;
var debugCurrentSphere;
var debugTargetSphere;
//End Screen Saver

//CSV
const numberOfIndices = indexCsv.length;
var indexSearchValue = '';
var indexImages = Array(numberOfIndices);

let indexContent = document.getElementById('index-content');
let indexCategoryMap = [];
let currentCategory = '';
for(let indexNum = 0; indexNum < numberOfIndices; indexNum++)
{
  indexCsv[indexNum].lowercasename = indexCsv[indexNum].name.toLocaleLowerCase();
  // indexImages[indexNum] = require(`./index/${indexCsv[indexNum].category}/${indexCsv[indexNum].filename}`);

  let indexText = document.createElement("p");
  indexText.innerHTML = indexCsv[indexNum].name;
  indexText.style = 'cursor: pointer';
  indexText.addEventListener('click', function(){
    if(this.nextSibling.style.display=='none')
      this.nextSibling.style.display='block';
    else
      this.nextSibling.style.display='none';
  })
  indexCsv[indexNum].textElement = indexText;

  let indexImage = document.createElement("img");
  indexImage.setAttribute('loading','lazy');
  indexImage.classList.add('noselect');
  indexImage.classList.add('index-img');
  indexImage.setAttribute('src',`./index/${indexCsv[indexNum].category}/${indexCsv[indexNum].filename}`);
  indexCsv[indexNum].imageElement = indexImage;

  if(indexCsv[indexNum].category != currentCategory)
  {
    currentCategory = indexCsv[indexNum].category;
    let indexCategory = document.createElement("p");
    indexCategory.classList.add("text-bold");
    indexCategory.classList.add("index-category");
    indexCategory.innerHTML = currentCategory;
    indexContent.appendChild(indexCategory);
    indexCategoryMap[currentCategory] = indexCategory;
  }

  indexContent.appendChild(indexText);
  indexContent.appendChild(indexImage);
}
//END CSV

var soundList = {};
soundList[0] = new Audio('sound/Encyclopedia.wav');
soundList[1] = new Audio('sound/eureka.wav');
soundList[2] = new Audio('sound/MercuryPlayBack.wav');
soundList[4] = new Audio('sound/planet7282m2.wav');
soundList[10] = new Audio('sound/AboutGroundWaterLightandAir.wav');
soundList[20] = new Audio('sound/nonexhibition.wav');
soundList[30] = new Audio('sound/hoyoencyclopedia.wav');
soundList[0].addEventListener('ended', function(){ if(!showingWorksVideo) mainthemeaudio.play(); })
soundList[1].addEventListener('ended', function(){ if(!showingWorksVideo) mainthemeaudio.play(); })
soundList[2].addEventListener('ended', function(){ if(!showingWorksVideo) mainthemeaudio.play(); })
soundList[4].addEventListener('ended', function(){ if(!showingWorksVideo) mainthemeaudio.play(); })
soundList[10].addEventListener('ended', function(){ if(!showingWorksVideo) mainthemeaudio.play(); })
soundList[20].addEventListener('ended', function(){ if(!showingWorksVideo) mainthemeaudio.play(); })
soundList[30].addEventListener('ended', function(){ if(!showingWorksVideo) mainthemeaudio.play(); })

var soundOn = false;
var audio;
var mainthemeaudio = new Audio('sound/maintheme.wav');
mainthemeaudio.loop = true;
var audioPlayed = false;
var showingWorksVideo = false;

//https://stackoverflow.com/questions/68594620/automatically-play-audio-object-in-javascript
// mainthemeaudio.addEventListener("canplaythrough", () => {
//   try {
//     mainthemeaudio.play()
//     document.getElementById('sound-off').style.display = 'none'
//     document.getElementById('sound-on').style.display = 'block'
//     soundOn = true;
//     audioPlayed = true;
//   }
//   catch(e) {
//      window.addEventListener('click', () => {
//       mainthemeaudio.play();
//       document.getElementById('sound-off').style.display = 'none'
//       document.getElementById('sound-on').style.display = 'block'
//       soundOn = true;
//       audioPlayed = true;
//      }, { once: true })
//   }
// });
document.body.addEventListener("click",function(){
  if(!audioPlayed)
  {
    audioPlayed=true;
    mainthemeaudio.play();
    document.getElementById('sound-off').style.display = 'none'
    document.getElementById('sound-on').style.display = 'block'
    soundOn = true;
  }
})

document.getElementById('sound-off').addEventListener('click',function(){
  if(!soundOn)
  {
    // console.log('sound on')
    soundOn = true;
    document.getElementById('sound-off').style.display = 'none'
    document.getElementById('sound-on').style.display = 'block'
    if(mainthemeaudio && !showingWorksVideo)
    {
      mainthemeaudio.play();
    }
    // if(audio)
    // {
    //   audio.currentTime = 0;
    //   audio.play();
    // }
  }
})

document.getElementById('sound-on').addEventListener('click',function(){
  if(soundOn)
  {
    // console.log('sound off')
    soundOn = false;
    document.getElementById('sound-off').style.display = 'block'
    document.getElementById('sound-on').style.display = 'none'
    if(mainthemeaudio)
    {
      mainthemeaudio.pause();
    }
    if(audio)
    {
      audio.pause();
    }
  }
})

const webTitle = 'Project Encyclopedia';

let existingContents = ['0', '1', '2', '4', '10', 'about'];
var contentNum = 'none';
let isLazy = [true, false, false, false, true, false, false, false, false, false, true];

var isDebug = false;
var container, controls, progressBar, threejsElement;
var camera, scene, renderer;
var labelRenderer;
var bgTexture;

var light;
let useLight = false;

let preventScroll = true;
let useHoverScale = true;

if(useLight)
{
  light = new THREE.PointLight(0xFF4400, 1);
  light.position.set(0,0,1);
} 
let lightIntensity = 0.5;

var preventDefault = false;

var allLoaded = false;
var loadingValue = 0;
var totalObjects = 9 + 14 + 3 + 3 + 1; //compass included

var limitFramerate = false;
var framerate = 30;

var stats;
var showStats = false;

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

if(mobileCheck())
{
  useHoverScale = false;
  isMobile = true;
}

let focusStartObject;
let focusStartObjectLoaded = false;

// Camera Setting
{
  var camPosX = 0; // -x to x is left to right
  var camPosY = 0; // y is camera up and down
  var camPosZ = 10; // +z farther from origin, -z into the origin
  var fov = 30;
  var aspect = window.innerWidth / window.innerHeight;
  var near = 0.25;
  var far = 20;
}


var useControls = true;
var showGrid = false;

var orbitHeight = 5;
// var orbitLength = orbitHeight * 1.465;
var orbitLength = orbitHeight * 1.777;

var selectableObjects = [];

{
var planets = [];
var planetScale = [0.1, 1.1, 1.0, 1.0, 1.0, 1.0, 1.0, 1.2, 0.9];
var planetRotation = [0.3, 0.8, 1.2, 1.0, 0.5, 0.56, 0.7, 0.6, 0.3, 1.0];
var planetRevolution = [0.01, 0.06, 0.05, 0.045, 0.037, 0.026, 0.021, 0.012, 0.007, 0.002];
var planetOrbitX = [0, 0.36, 0.6, 0.75, 0.92, 1.66, 1.87, 2.17, 2.4, 3.4];
var planetOrbitY = [0, 0.36, 0.6, 0.75, 0.92, 1.66, 1.87, 2.17, 2.4, 2.7];
var planetTiltOffset = [0, -0.1, -0.12, -0.08, 0.2, 0.26, -0.14, 0.1, 0.22, 0.1];
var planetRotationOffset = [0, 2.0, 0.5, 3, 0.88, 1.35, 11.75, -2.1, 2.6, 4];
var planetRevolutionOffset = [0, 5, 0.5, 3, 0.88, 1.35, 11.75, -2.1, 2.6, 4];
var planetDestZ = [8.9, 9.2, 9, 9, 9, 8.6, 8.8, 8.8, 8.4];
var planetExhibition = [true, true, false, true, false, false, false, false, false];
var planetReferencePrefix = ['', 2, 3, 4, 6, 9, 14, 22, 23];
var planetNumOfReferences = [170, 44, 31, 26, 16, 12, 17, 24, 29];
var planetName = ["Sun", "Mercury", "Venus", "Earth", "Mars", "Jupiter", "Saturn", "Uranus", "Neptune"];

// 4-1
var moon;
var moonScale = 0.32;
var moonRotation = 0.3;
var moonRevolution = 1; 
var moonOrbitX = 0.18; 
var moonOrbitY = 0.18; 
var moonTiltOffset = 0.05;
var moonRotationOffset = 0;
var moonRevolutionOffset = 0;
var moonDestZ = 9.4;
var moonReferencePrefix = 5;
var moonNumOfReferences = 20;
var moonName = "Moon";

// 5-1, 5-2
var marsMoon = [];
var marsMoonScale = [0.65, 0.65];
var marsMoonRotation = [0.3, 0.8];
var marsMoonRevolution = 0.5; 
var marsMoonOrbitX = 0.16; 
var marsMoonOrbitY = 0.16; 
var marsMoonTiltOffset = [0.4, -0.25];
var marsMoonRotationOffset = [0, 5];
var marsMoonRevolutionOffset = [0, Math.PI];
var marsMoonDestZ = [9.3, 9.3];
var marsMoonReferencePrefix = [7, 8];
var marsMoonNumOfReferences = [8, 6];
var marsMoonName = ["Phobos", "Deimos"];

// 6-1, 6-2, 6-3, 6-4
var jupiterMoon = [];
var jupiterMoonScale = [0.6, 0.6, 0.7, 1.8]; //milk, soccer, water, teddy
var jupiterMoonRotation = [0.6, 0.8, 1.2, 1.0];
var jupiterMoonRevolution = 0.4; 
var jupiterMoonOrbitX = 0.27; 
var jupiterMoonOrbitY = 0.27; 
var jupiterMoonTiltOffset = [0, -0.1, -0.12, -0.08];
var jupiterMoonRotationOffset = [0, 5, 0.5, 3];
var jupiterMoonRevolutionOffset = [0, Math.PI/2, Math.PI, 3*Math.PI/2];
var jupiterMoonDestZ = [9.2, 9.3, 9.3, 9.3];
var jupiterMoonReferencePrefix = [10, 11, 12, 13];
var jupiterMoonNumOfReferences = [11, 22, 10, 11];
var jupiterMoonName = ["Io", "Europa", "Ganimede", "Callisto"];

// 7-1 ~ 7-7
var saturnMoon = [];
var saturnMoonScale = [0.9, 1.2, 1.1, 1.4, 0.65, 0.7, 0.9]; //bread, candle, duck, soap, confrost, pan, driver
var saturnMoonRotation = [0.4, 0.8, 1.2, 1.0, 1.0, 1.0, 1.0];
var saturnMoonRevolution = 0.3; 
var saturnMoonOrbitX = 0.3; 
var saturnMoonOrbitY = 0.3; 
var saturnMoonTiltOffset = [0, -0.1, -0.12, -0.08, -0.1, -0.12, -0.08];
var saturnMoonRotationOffset = [0, 5, 0.5, 3, 5, 0.5, 3];
var saturnMoonRevolutionOffset = [0, 2*Math.PI/7, 2*Math.PI/7*2, 2*Math.PI/7*3, 2*Math.PI/7*4, 2*Math.PI/7*5, 2*Math.PI/7*6];
var saturnMoonDestZ = [9.4, 9.4, 9.2, 9.3, 9.4, 9.2, 9.4];
var saturnMoonReferencePrefix = [15, 16, 17, 18, 19, 20, 21];
var saturnMoonNumOfReferences = [12, 13, 25, 14, 13, 23, 15];
var saturnMoonName = ["Mimas", "Enceladus", "Tethys", "Dione", "Rhea", "Titan", "Iapetus"];

// belt
var beltOriginXInitialLandscape = 2.6;
var beltOriginYInitialLandscape = 2.0;
var beltOriginXInitialPortrait = 1.1;
var beltOriginYInitialPortrait = 2.2;
var beltOriginXInitial, beltOriginYInitial;

// cursor
var compass;
var compassScale = 0.6;
var compassRotation = {
  x: 0.1,
  y: 0.1,
  z: 0
}
var compassDestZ = 9.4;
var compassRotationSpeed = 0.5;

if(window.innerHeight > window.innerWidth){
  beltOriginXInitial = beltOriginXInitialPortrait;
  beltOriginYInitial = beltOriginYInitialPortrait;
}
else
{
  beltOriginXInitial = beltOriginXInitialLandscape;
  beltOriginYInitial = beltOriginYInitialLandscape;
}

var beltOriginX = beltOriginXInitial;
var beltOriginY = beltOriginYInitial;
var beltOriginChanged = false;
var belt = [];
var beltScale = [0.2, 0.2, 0.2];
var beltRotation = [0.5, 0.8, 0.8];
var beltRevolution = 0.3; 
var beltOrbitX = 0.16; 
var beltOrbitY = 0.16; 
var beltTiltOffset = [0.4, -0.25, 0.1];
var beltRotationOffset = [0, 5, 3];
var beltRevolutionOffset = [0, 2*Math.PI/3, 2*Math.PI/3*2];
var beltDestZ = 8.3;
var beltNumOfReferences = 48;
var beltName = "Kuiper Belt";
}

var orbitMaterial, lightMaterial, blackMaterial;
var sunObject;

var raycaster = new THREE.Raycaster();
var mouse = new THREE.Vector2();
var outlinePass;

var isFocused = false;
var isHovered = false;
var inAnimation = false;
var focusedObject = null;
var hoveredObject = null;
var isCancel = false;
var isInMenu = false;
var isModal = false;

var destFrame = 30;
var curFrame = 0;
var destZ = 8.5;
var sourceX = 0;
var sourceY = 0;

var hoverDestScale = 1.5;

var isProjectEncyclopedia = false;
var projectEncyclopediaDisabledOpacity = 0.0;

var backgroundScale = 1.0;
// var backgroundOpacity = 0.25;
var backgroundOpacity = 1;
var backgroundImg;

var zoomSmaller;

class PickHelper {

  constructor() 
  {
    this.raycaster = new THREE.Raycaster();
    this.pickedObject = null;
    this.pickedObjectSavedColor = 0;
    this.hoveredObject = null;
  }

  pick(normalizedPosition, scene, camera, objectArray, _destZ) 
  {
    if(isScreenSaverMode) return;

    if (this.pickedObject) 
    {
      isFocused = false;
      this.pickedObject = undefined;
      if(focusedObject)
      {
        focusedObject.parent.position.z = 0;
        if(focusedObject.isBelt)
        {
         
          beltOriginX = beltOriginXInitial;
          beltOriginY = beltOriginYInitial;
          for(let k=0;k<3;k++)
          {
            belt[k].parent.position.z = 0;
          }
        }
      }
        
      blackMaterial.opacity = 0.0;
      document.getElementById ("project-encyclopedia-about").style.opacity = 1.0;
      document.getElementById ("project-encyclopedia").style.opacity = 1.0;
      document.getElementById ("content").style.opacity = 0.0;

      setExhibitionLabelOpacity(1.0);
      
      focusedObject = undefined;
      curFrame = 0;
      for(let k=0;k<scene.children.length;k++)
      {
        scene.children.opacity = 1.0;
      }
      $('#content').css('display', 'none');
      document.getElementById('c').getElementsByTagName('canvas')[0].style.pointerEvents = 'auto';
    }
 
    // cast a ray through the frustum
    this.raycaster.setFromCamera(normalizedPosition, camera);

    // get the list of objects the ray intersected
    const intersectedObjects = this.raycaster.intersectObjects(objectArray, true);

    if (intersectedObjects instanceof Array && intersectedObjects.length) 
    {
      // pick the first object. It's the closest one
      this.pickedObject = intersectedObjects[0].object;

      while(this.pickedObject.parent!=null && this.pickedObject.type!=='Object3D')
      {
        this.pickedObject = this.pickedObject.parent;
      }

      while(this.pickedObject.parent!=null && this.pickedObject.parent.type=='Object3D')
      {
        this.pickedObject = this.pickedObject.parent;
      }

      console.log(this.pickedObject);
      focusedObject = this.pickedObject;
      
      document.getElementById('c').getElementsByTagName('canvas')[0].style.pointerEvents = 'none';

      destZ = focusedObject.destZ;
      isFocused = true;

      showContent();
    }
    
  }

  move(normalizedPosition, scene, camera, objectArray, _destZ) 
  {
    if(isScreenSaverMode) return;

    if (this.hoveredObject) 
    {
      isHovered = false;
      this.hoveredObject = undefined;
      hoveredObject = undefined;
    }
 
    // cast a ray through the frustum
    this.raycaster.setFromCamera(normalizedPosition, camera);

    // get the list of objects the ray intersected
    const intersectedObjects = this.raycaster.intersectObjects(objectArray, true);

    if (intersectedObjects instanceof Array && intersectedObjects.length) 
    {
      // pick the first object. It's the closest one
      this.hoveredObject = intersectedObjects[0].object;

      while(this.hoveredObject.parent!=null && this.hoveredObject.type!=='Object3D')
      {
        this.hoveredObject = this.hoveredObject.parent;
      }

      while(this.hoveredObject.parent!=null && this.hoveredObject.parent.type=='Object3D')
      {
        this.hoveredObject = this.hoveredObject.parent;
      }

      hoveredObject = this.hoveredObject;

      isHovered = true;
    }
    
  }
}



const pickPosition = {x: 0, y: 0};
const pickHelper = new PickHelper();
clearPickPosition();

function setOpacityToObject(obj,val) {
  if(!obj) return;
  console.log(obj.name);
  if(obj.children)
  {
    for(let i = 0; i < obj.children.length; i++)
    {
      setOpacityToObject(obj.children[i],val);
    }
  }

  if(obj.material)
  {
    obj.material.transparent=true;
    obj.material.opacity = val;
    console.log(obj.name+' opacity set to '+val)
  }
}

init();

function init() {

  container = document.querySelector('#c');
  progressBar = document.getElementById("load-progress");
  resizeContent();

  if(showStats)
  {
    stats = new Stats();
    stats.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom
    document.body.appendChild( stats.dom );
  }

  scene = new THREE.Scene();

  // CAMERA SETTINGS
  {
    
    aspect = window.innerWidth / window.innerHeight;
    camera = new THREE.PerspectiveCamera( fov, aspect, near, far );
    camera.position.set(camPosX, camPosY, camPosZ);
    camera.updateProjectionMatrix();
    currentRenderCamera = camera;

    if(aspect < 0.7)
    {
      zoomSmaller = true;
    }
    else
    {
      zoomSmaller = false;
    }


    // SCREEN SAVER CAMERA
    {
      screenSaverCamera = new THREE.PerspectiveCamera( fov, aspect, near, far );
      screenSaverCamera.up.set(0,0,1);
      screenSaverCamera.position.set(camPosX, camPosY, camPosZ);
      screenSaverCamera.near = 0.01;
      screenSaverCamera.far = 5000;
      screenSaverCamera.updateProjectionMatrix();
    }
  }
  
  // ORBIT & LIGHT PLANE
  {
    // BACKGROUND
    const loader = new THREE.TextureLoader();
    bgTexture = loader.load('background_lg_noorbit.png', function() {
      // console.log('Background Loaded');
      checkLoadedObjects();
    });
    
    var backgroundMaterial = new THREE.MeshStandardMaterial({
      map: bgTexture,
      // side: THREE.DoubleSide,
      // transparent: true,
    });
    // backgroundMaterial.opacity = backgroundOpacity;
    // backgroundMaterial.clipIntersection = true;
    // backgroundMaterial.precision = "highp";
    //scene.background = backgroundMaterial;

    // var newBackgroundMaterial = new THREE.SpriteMaterial({
    //   map: bgTexture,
    //   color: 0xffffff
    // });
    // const sprite = new THREE.Sprite( newBackgroundMaterial );
    // sprite.scale.set(5*1.777*1.2, 5*1.2, 1)
    // scene.add( sprite );

    let lightGeometrySizeFactor = 1.2;
    const lightGeometry = new THREE.PlaneBufferGeometry(5*1.465*lightGeometrySizeFactor, 5*lightGeometrySizeFactor);
    //const backgroundGeometry = new THREE.PlaneBufferGeometry(4689, 3659);
    let backgroundOrbitRatio = 1.0;
    const blackBackgroundGeometry = new THREE.PlaneBufferGeometry(20, 20);
    const backgroundGeometry = new THREE.PlaneBufferGeometry(5*1.8*1.25, 5*1.8*1.25);
    const orbitGeometry = new THREE.PlaneBufferGeometry(5*1.8*1.25/4800*3840, 5*1.8*1.25/4800*2160);
    const blackGeometry = new THREE.PlaneBufferGeometry(30, 30);
    var orbitLoader = new THREE.TextureLoader();
    var orbitTexture = orbitLoader.load('resource/orbits.png', function() {
      // console.log('Orbit Loaded');
      checkLoadedObjects();
    });
    var lightTexture = orbitLoader.load('resource/light.png', function() {
      // console.log('Light Loaded');
      checkLoadedObjects();
    });
    orbitMaterial = new THREE.MeshStandardMaterial({
      map: orbitTexture,
      // side: THREE.DoubleSide,
      transparent: true,
    });
    lightMaterial = new THREE.MeshBasicMaterial({
      map: lightTexture,
      side: THREE.DoubleSide,
      transparent: true,
    });
    blackMaterial = new THREE.MeshBasicMaterial({color: 0x000000, transparent: true});
    const blackBackgroundMaterial = new THREE.MeshStandardMaterial({color: 0x000000});
    blackMaterial.opacity = 0.0;
    document.getElementById ("project-encyclopedia").style.opacity = 1.0;
    document.getElementById ("project-encyclopedia-about").style.opacity = 1.0;
    document.getElementById ("content").style.opacity = 0.0;
    const orbitImg = new THREE.Mesh(orbitGeometry, orbitMaterial);
    const lightImg = new THREE.Mesh(lightGeometry, lightMaterial);
    const blackScreen = new THREE.Mesh(blackGeometry, blackMaterial);
    const blackBackgroundImg = new THREE.Mesh(blackBackgroundGeometry, blackBackgroundMaterial);
    backgroundImg = new THREE.Mesh(backgroundGeometry, backgroundMaterial);
    lightImg.renderOrder = -2;
    orbitImg.renderOrder = -1;
    // orbitMaterial.opacity = 0.7;

    if(isDebug)
    {
      const radius = 0.03;
      const widthSegments = 12;
      const heightSegments = 8;
      const sphereGeometry = new THREE.SphereBufferGeometry(radius, widthSegments, heightSegments);
      const sphereMaterial1 = new THREE.MeshBasicMaterial({color: 0x00ff00});
      const sphereMaterial2 = new THREE.MeshBasicMaterial({color: 0xff0000});
      debugCurrentSphere = new THREE.Mesh(sphereGeometry, sphereMaterial1);
      debugStartSphere = new THREE.Mesh(sphereGeometry, sphereMaterial2);
      debugTargetSphere = new THREE.Mesh(sphereGeometry, sphereMaterial2);
      scene.add(debugCurrentSphere);
      scene.add(debugStartSphere);
      scene.add(debugTargetSphere);
      debugCurrentSphere.visible = false;
      debugStartSphere.visible = false;
      debugTargetSphere.visible = false;
    }

    // orbitImg.position.x = -0.09;
    // orbitImg.position.y = 0.15;
    orbitImg.position.z = -0.04;
    // lightImg.position.x = -0.09;
    // lightImg.position.y = 0.15;
    lightImg.position.z = -0.14;
    blackScreen.position.z = 1;
    // backgroundImg.position.z = -0.15;
    backgroundImg.position.z = -0.9;
    // backgroundImg.scale.x = backgroundScale;
    // backgroundImg.scale.y = backgroundScale;
    lightImg.scale.x = 1.5;
    lightImg.scale.y = 1.5;
    blackBackgroundImg.position.z = -5;
    backgroundImg.frustumCulled = false;

    scene.add(orbitImg);
    scene.add(lightImg);
    scene.add(blackScreen);
    scene.add(backgroundImg);
    scene.add(blackBackgroundImg);
  }


  


  new RGBELoader()
    .setDataType( THREE.UnsignedByteType )
    .load( 'royal_esplanade_1k.hdr', function ( texture ) {
      
      var envMap = pmremGenerator.fromEquirectangular( texture ).texture;

      scene.environment = envMap;
      
      texture.dispose();
      pmremGenerator.dispose();


      if(showGrid)
      {
        var gridHelper = new THREE.GridHelper( 28, 28, 0x303030, 0x303030 );
        scene.add( gridHelper );
      }

      var loader = new GLTFLoader();

      for(let i=1;i<=9;i++)
      {
        loader.load( 'resource/'+i.toString()+'.gltf', function ( gltf ) {
        gltf.scene.traverse( function ( child ) {
          if ( child.isMesh ) {
            // TOFIX RoughnessMipmapper seems to be broken with WebGL 2.0
            // roughnessMipmapper.generateMipmaps( child.material );
          }
        } );

        var objScale = planetScale[i-1];
        gltf.scene.children[0].scale.x = objScale;
        gltf.scene.children[0].scale.y = objScale;
        gltf.scene.children[0].scale.z = objScale;
        gltf.scene.rotation.z = planetTiltOffset[i-1];

        scene.add( gltf.scene );
        planets[i-1]=gltf.scene.children[0];

        planets[i-1].orbitX = planetOrbitX[i-1];
        planets[i-1].orbitY = planetOrbitY[i-1];
        planets[i-1].revolution = planetRevolution[i-1];
        planets[i-1].revolutionOffset = planetRevolutionOffset[i-1];
        planets[i-1].destZ = planetDestZ[i-1];
        planets[i-1].isMoon = false;
        planets[i-1].isBelt = false;
        planets[i-1].isExhibition = planetExhibition[i-1];
        planets[i-1].directoryName = i.toString();
        planets[i-1].referencePrefix = planetReferencePrefix[i-1].toString();
        planets[i-1].numOfReferences = planetNumOfReferences[i-1];
        planets[i-1].name = planetName[i-1];
        planets[i-1].originalScale = objScale;

        //if(i==2) focusStartObject = gltf.scene.children[0];

        selectableObjects.push(gltf.scene.children[0]);
        
        if(planets[i-1].isExhibition)
        {
          let labelDiv = document.createElement( 'div' );
          labelDiv.className = 'exhibition-label';
          if(i==1)
          {
            labelDiv.textContent = 'eureka';
            labelDiv.id = 'exhibition-label-1';
            labelDiv.style.marginTop = '3em';
            // labelDiv.style.fontSize = '12px';
          }
          if(i==2)
          {
            labelDiv.textContent = 'Mercury Play Back';
            labelDiv.id = 'exhibition-label-2';
            labelDiv.style.marginTop = '1.5em';
          }
          else if(i==4)
          {
            labelDiv.textContent = 'Planet 72.82m²';
            labelDiv.id = 'exhibition-label-4';
            labelDiv.style.marginTop = '1em';
          }
          
          
          var exhibitionLabel = new CSS2DObject( labelDiv );
          //exhibitionLabel.position.set( 0, Sensor.threeSensorRadius * 1.5, 0 );
          gltf.scene.add( exhibitionLabel );
        }

        if(i==1)
        {
          // gltf.scene.children[0].children[0].material.color.r=1;
          // gltf.scene.children[0].children[0].material.color.g=1;
          // gltf.scene.children[0].children[0].material.color.b=1;

          if(false)
          {
            gltf.scene.children[0].children[0].children[1].material.opacity=0.3;
            //yellow
            // sunObject = gltf.scene.children[0].children[0].children[1].material.emissive;
            // gltf.scene.children[0].children[0].children[1].material.emissive.r=0.6;
            // gltf.scene.children[0].children[0].children[1].material.emissive.g=0.2;
            // gltf.scene.children[0].children[0].children[1].material.emissive.b=0;
            //light blue
            gltf.scene.children[0].children[0].children[1].material.emissive.r=0;
            gltf.scene.children[0].children[0].children[1].material.emissive.g=0.15;
            gltf.scene.children[0].children[0].children[1].material.emissive.b=0.4;

          }

          console.log(gltf.scene.children[0].children[0].children[0].children[0])
          sunObject = gltf.scene.children[0].children[0].children[0].children[0].material;
          gltf.scene.children[0].children[0].children[0].children[0].material.emissive.r=0.6;
          gltf.scene.children[0].children[0].children[0].children[0].material.emissive.g=0.3;
          gltf.scene.children[0].children[0].children[0].children[0].material.emissive.b=0;
          // gltf.scene.children[0].children[0].children[0].children[1];
        }



        checkLoadedObjects();
        
        } );
      }
      {
        loader.load( 'resource/4-1'.toString()+'.gltf', function ( gltf ) {
        gltf.scene.traverse( function ( child ) {
          if ( child.isMesh ) {
            // TOFIX RoughnessMipmapper seems to be broken with WebGL 2.0
            // roughnessMipmapper.generateMipmaps( child.material );
          }
        } );

        var objScale = moonScale;
        gltf.scene.children[0].scale.x = objScale;
        gltf.scene.children[0].scale.y = objScale;
        gltf.scene.children[0].scale.z = objScale;
        gltf.scene.rotation.z = moonTiltOffset;
        

        scene.add( gltf.scene );
        moon=gltf.scene.children[0];

        moon.orbitX = moonOrbitX;
        moon.orbitY = moonOrbitY;
        moon.revolution = moonRevolution;
        moon.revolutionOffset = moonRevolutionOffset;
        moon.destZ = moonDestZ;
        moon.isMoon = true;
        moon.planetIndex = 3;
        moon.isBelt = false;
        moon.isExhibition = false;
        moon.directoryName = '4-1';
        moon.referencePrefix = moonReferencePrefix.toString();
        moon.numOfReferences = moonNumOfReferences;
        moon.name = moonName;
        moon.originalScale = objScale;
      
        selectableObjects.push(gltf.scene.children[0]);

        checkLoadedObjects();
        } );
      }
      for(let i=1;i<=2;i++)
      {
        loader.load( 'resource/5-'+i.toString()+'.gltf', function ( gltf ) {
        gltf.scene.traverse( function ( child ) {
          if ( child.isMesh ) {
            // TOFIX RoughnessMipmapper seems to be broken with WebGL 2.0
            // roughnessMipmapper.generateMipmaps( child.material );
          }
        } );

        var objScale = marsMoonScale[i-1];
        gltf.scene.children[0].scale.x = objScale;
        gltf.scene.children[0].scale.y = objScale;
        gltf.scene.children[0].scale.z = objScale;
        gltf.scene.rotation.z = marsMoonTiltOffset[i-1];
        

        scene.add( gltf.scene );
        marsMoon[i-1]=gltf.scene.children[0];

        marsMoon[i-1].orbitX = marsMoonOrbitX;
        marsMoon[i-1].orbitY = marsMoonOrbitY;
        marsMoon[i-1].revolution = marsMoonRevolution;
        marsMoon[i-1].revolutionOffset = marsMoonRevolutionOffset[i-1];
        marsMoon[i-1].destZ = marsMoonDestZ[i-1];
        marsMoon[i-1].isMoon = true;
        marsMoon[i-1].planetIndex = 4;
        marsMoon[i-1].isBelt = false;
        marsMoon[i-1].isExhibition = false;
        marsMoon[i-1].directoryName = '5-'+i.toString();
        marsMoon[i-1].referencePrefix = marsMoonReferencePrefix[i-1].toString();
        marsMoon[i-1].numOfReferences = marsMoonNumOfReferences[i-1];
        marsMoon[i-1].name = marsMoonName[i-1];
        marsMoon[i-1].originalScale = objScale;

        selectableObjects.push(gltf.scene.children[0]);
 
        checkLoadedObjects();

        } );
      }
      for(let i=1;i<=4;i++)
      {
        loader.load( 'resource/6-'+i.toString()+'.gltf', function ( gltf ) {
        gltf.scene.traverse( function ( child ) {
          if ( child.isMesh ) {
            // TOFIX RoughnessMipmapper seems to be broken with WebGL 2.0
            // roughnessMipmapper.generateMipmaps( child.material );
          }
        } );

        var objScale = jupiterMoonScale[i-1];
        gltf.scene.children[0].scale.x = objScale;
        gltf.scene.children[0].scale.y = objScale;
        gltf.scene.children[0].scale.z = objScale;
        gltf.scene.rotation.z = jupiterMoonTiltOffset[i-1];

        scene.add( gltf.scene );
        jupiterMoon[i-1]=gltf.scene.children[0];

        jupiterMoon[i-1].orbitX = jupiterMoonOrbitX;
        jupiterMoon[i-1].orbitY = jupiterMoonOrbitY;
        jupiterMoon[i-1].revolution = jupiterMoonRevolution;
        jupiterMoon[i-1].revolutionOffset = jupiterMoonRevolutionOffset[i-1];
        jupiterMoon[i-1].destZ = jupiterMoonDestZ[i-1];
        jupiterMoon[i-1].isMoon = true;
        jupiterMoon[i-1].planetIndex = 5;
        jupiterMoon[i-1].isBelt = false;
        jupiterMoon[i-1].isExhibition = false;
        jupiterMoon[i-1].directoryName = '6-'+i.toString();
        jupiterMoon[i-1].referencePrefix = jupiterMoonReferencePrefix[i-1].toString();
        jupiterMoon[i-1].numOfReferences = jupiterMoonNumOfReferences[i-1];
        jupiterMoon[i-1].numOfReferences = jupiterMoonNumOfReferences[i-1];
        jupiterMoon[i-1].name = jupiterMoonName[i-1];
        jupiterMoon[i-1].originalScale = objScale;

        selectableObjects.push(gltf.scene.children[0]);

        checkLoadedObjects();
        } );
      }
      for(let i=1;i<=7;i++)
      {
        loader.load( 'resource/7-'+i.toString()+'.gltf', function ( gltf ) {
        gltf.scene.traverse( function ( child ) {
          if ( child.isMesh ) {
            // TOFIX RoughnessMipmapper seems to be broken with WebGL 2.0
            // roughnessMipmapper.generateMipmaps( child.material );
          }
        } );
        var objScale = saturnMoonScale[i-1];
        gltf.scene.children[0].scale.x = objScale;
        gltf.scene.children[0].scale.y = objScale;
        gltf.scene.children[0].scale.z = objScale;
        gltf.scene.rotation.z = saturnMoonTiltOffset[i-1];

        scene.add( gltf.scene );
        saturnMoon[i-1]=gltf.scene.children[0];

        saturnMoon[i-1].orbitX = saturnMoonOrbitX;
        saturnMoon[i-1].orbitY = saturnMoonOrbitY;
        saturnMoon[i-1].revolution = saturnMoonRevolution;
        saturnMoon[i-1].revolutionOffset = saturnMoonRevolutionOffset[i-1];
        saturnMoon[i-1].destZ = saturnMoonDestZ[i-1];
        saturnMoon[i-1].isMoon = true;
        saturnMoon[i-1].planetIndex = 6;
        saturnMoon[i-1].isBelt = false;
        saturnMoon[i-1].isExhibition = false;
        saturnMoon[i-1].directoryName = '7-'+i.toString();
        saturnMoon[i-1].referencePrefix = saturnMoonReferencePrefix[i-1].toString();
        saturnMoon[i-1].numOfReferences = saturnMoonNumOfReferences[i-1];
        saturnMoon[i-1].name = saturnMoonName[i-1];
        saturnMoon[i-1].originalScale = objScale;

        selectableObjects.push(gltf.scene.children[0]);

        checkLoadedObjects();
        } );
      }
      for(let i=1;i<=3;i++)
      {
        loader.load( 'resource/10-'+i.toString()+'.gltf', function ( gltf ) {
        gltf.scene.traverse( function ( child ) {
          if ( child.isMesh ) {
            // TOFIX RoughnessMipmapper seems to be broken with WebGL 2.0
            // roughnessMipmapper.generateMipmaps( child.material );
          }
        } );

        var objScale = beltScale[i-1];
        gltf.scene.children[0].scale.x = objScale;
        gltf.scene.children[0].scale.y = objScale;
        gltf.scene.children[0].scale.z = objScale;
        gltf.scene.rotation.z = beltTiltOffset[i-1];

        scene.add( gltf.scene );
        belt[i-1]=gltf.scene.children[0];

        belt[i-1].orbitX = beltOrbitX;
        belt[i-1].orbitY = beltOrbitY;
        belt[i-1].revolution = beltRevolution;
        belt[i-1].revolutionOffset = beltRevolutionOffset[i-1];
        belt[i-1].destZ = 8.5;
        belt[i-1].isMoon = false;
        belt[i-1].isBelt = true;
        belt[i-1].isExhibition = true;
        belt[i-1].directoryName = '10';
        belt[i-1].referencePrefix = '';
        belt[i-1].numOfReferences = beltNumOfReferences;
        belt[i-1].name = beltName;
        belt[i-1].originalScale = objScale;

        selectableObjects.push(gltf.scene.children[0]);

        if(i==1)
        {
          let labelDiv = document.createElement( 'div' );
          labelDiv.className = 'exhibition-label';
          labelDiv.id = 'exhibition-label-10';

          labelDiv.textContent = 'About Ground Water Light and Air';

          
          labelDiv.style.marginTop = '-1em';
          var exhibitionLabel = new CSS2DObject( labelDiv );
          //exhibitionLabel.position.set( 0, Sensor.threeSensorRadius * 1.5, 0 );
          gltf.scene.add( exhibitionLabel );
        }
          
        
        
        
        checkLoadedObjects();
        } );
      }

      {
        loader.load( 'resource/compass.gltf', function ( gltf ) {
          gltf.scene.traverse( function ( child ) {
            if ( child.isMesh ) {
              // TOFIX RoughnessMipmapper seems to be broken with WebGL 2.0
              // roughnessMipmapper.generateMipmaps( child.material );
            }
          } );

          var objScale = compassScale;
          gltf.scene.children[0].scale.x = objScale;
          gltf.scene.children[0].scale.y = objScale;
          gltf.scene.children[0].scale.z = objScale;
          gltf.scene.rotation.x = compassRotation.x;
          gltf.scene.rotation.y = compassRotation.y;
          gltf.scene.rotation.z = compassRotation.z;

          
          
          gltf.scene.position.z = 0;


          scene.add( gltf.scene );
          compass=gltf.scene.children[0];
          compass.destZ = compassDestZ;
          compass.visible = false;
          checkLoadedObjects();
        } );
      }


      /*
      var objLoader = new OBJLoader2();

      // load a resource
      

      {
        let i = 5;
        const mtlLoader = new MTLLoader();
        mtlLoader.load('resource/7-'+i.toString()+'.mtl', (mtlParseResult) => {
          const objLoader = new OBJLoader2();
          const materials =  MtlObjBridge.addMaterialsFromMtlLoader(mtlParseResult);
          //objLoader.addMaterials(materials);
          objLoader.load('resource/7-'+i.toString()+'.obj', (object) => {
            //scene.add(object);
    
            // compute the box that contains all the stuff
            // from root and below
           let objScene = new THREE.Scene();
          
           
           var objScale = saturnMoonScale[i-1];
           objScale /=700;
           object.scale.x = objScale;
           object.scale.y = objScale;
           object.scale.z = objScale;
           objScene.position.x=0;
           objScene.position.y=0;
           objScene.position.z=0;
           objScene.add(object);
           objScene.rotation.z = saturnMoonTiltOffset[i-1];
           
           scene.add( objScene );
           saturnMoon[i-1]=object;
 
           saturnMoon[i-1].orbitX = saturnMoonOrbitX;
           saturnMoon[i-1].orbitY = saturnMoonOrbitY;
           saturnMoon[i-1].revolution = saturnMoonRevolution;
           saturnMoon[i-1].revolutionOffset = saturnMoonRevolutionOffset[i-1];
           saturnMoon[i-1].destZ = saturnMoonDestZ[i-1];
           saturnMoon[i-1].isMoon = true;
           saturnMoon[i-1].planetIndex = 6;
           saturnMoon[i-1].isBelt = false;
           saturnMoon[i-1].isExhibition = false;
           saturnMoon[i-1].directoryName = '7-'+i.toString();
           saturnMoon[i-1].referencePrefix = saturnMoonReferencePrefix[i-1].toString();
           saturnMoon[i-1].numOfReferences = saturnMoonNumOfReferences[i-1];
           saturnMoon[i-1].name = saturnMoonName[i-1];
 
           selectableObjects.push(object);
           console.log(saturnMoon[i-1]);
           console.log('Object 7-'+i+' Loaded');
           
           checkLoadedObjects();
          });
        });
      }
      */
      if(useLight)
      {
        scene.add(light);
      }


      

    } );

  

  // RENDERER & CONTAINER
  {
    renderer = new THREE.WebGLRenderer( { antialias: true, alpha: true } );
    renderer.setPixelRatio( window.devicePixelRatio );
    renderer.setSize( window.innerWidth, window.innerHeight );
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1;
    renderer.outputEncoding = THREE.sRGBEncoding;
    threejsElement = container.appendChild( renderer.domElement );
    // console.log("renderer.localClippingEnabled")
    // console.log(renderer.localClippingEnabled)
    // renderer.localClippingEnabled=true;

    labelRenderer = new CSS2DRenderer();
		labelRenderer.setSize( window.innerWidth, window.innerHeight );
		labelRenderer.domElement.style.position = 'absolute';
		labelRenderer.domElement.style.top = '0px';
		labelRenderer.domElement.style.pointerEvents = 'none';
    container.appendChild( labelRenderer.domElement );
    

    /*
    renderer.domElement.style.position = 'fixed';
    renderer.domElement.style.left = '0px';
    renderer.domElement.style.top = '0px';
    renderer.domElement.style.zIndex = '-1';
    */
    var pmremGenerator = new THREE.PMREMGenerator( renderer );
    pmremGenerator.compileEquirectangularShader();
  }
  
  // ORBIT CONTROLS
  if(useControls)
  {
    controls = new OrbitControls( camera, renderer.domElement );
    //controls.addEventListener( 'change', render ); // use if there is no animation loop
    //controls.minDistance = 2;
    controls.minDistance = 3; //6
    //controls.maxDistance = 10;
    {
      controls.maxDistance = 10;
    }
    
    controls.mouseButtons = {
      // LEFT: THREE.MOUSE.ROTATE,
      // MIDDLE: THREE.MOUSE.DOLLY,
      // RIGHT: THREE.MOUSE.PAN
      LEFT: THREE.MOUSE.PAN,
      MIDDLE: THREE.MOUSE.DOLLY
    };
    controls.touches = {
      // ONE: THREE.TOUCH.ROTATE,
      // TWO: THREE.TOUCH.DOLLY_PAN
      ONE: THREE.TOUCH.PAN,
      TWO: THREE.TOUCH.DOLLY_PAN
    };
    controls.enablePan = true;
    controls.enableZoom = true;
    controls.enableRotate = true;
    controls.target.set( 0, 0, - 0.2 );
    // var minPan = new THREE.Vector3( - 2, -1, -0.2 );
    // var maxPan = new THREE.Vector3( 2, 1, -0.2 );
    var panXValue = 1.5;
    var panYValue = 1.5;
    var maxDistPanXvalue = 1.5;
    var maxDistPanYvalue = 1.5; //0.1

    var xRange = panXValue - maxDistPanXvalue;
    var yRange = panYValue - maxDistPanYvalue;
    var zRange = controls.maxDistance - controls.minDistance;
    
    var _v = new THREE.Vector3();
    
    controls.addEventListener("change", function() {
        // var kVal = ((controls.position0.z - controls.minDistance) / zRange);
        // if(kVal<0) kVal = 0;
        // kVal = Math.sqrt(kVal)
        // var adjustedXValue = panXValue - (kVal * xRange);
        // var adjustedYValue = panYValue - (kVal * yRange);
        var adjustedXValue = 2;
        var adjustedYValue = 2;
        var minPan = new THREE.Vector3( -adjustedXValue, -adjustedYValue, -0.2 );
        var maxPan = new THREE.Vector3( adjustedXValue, adjustedYValue, -0.2 );
      
        _v.copy(controls.target);
        controls.target.clamp(minPan, maxPan);
        _v.sub(controls.target);
        camera.position.sub(_v);
        // console.log(controls.target)
        // console.log("position: "+controls.position0.z);
    })

    //createLimitPan({camera, controls, THREE});
    controls.update();
    //console.log(controls.position0);
  }

  // EVENT LISTENERS
  {
    window.addEventListener('resize', onWindowResize, false);
    //window.addEventListener('deviceorientation', onWindowResize, false);
    window.addEventListener('orientationchange', onWindowResize, false);

    //window.addEventListener( 'mousemove', onMouseMove, false );
    window.addEventListener('mousemove', setPickPosition);
    window.addEventListener('mouseout', clearPickPosition);
    window.addEventListener('mouseleave', clearPickPosition);
    
    window.addEventListener('touchstart', (event) => {
      if(allLoaded==true&&isFocused==false)
      {
        // prevent the window from scrolling
        if(preventDefault) event.preventDefault();
        setPickPosition(event.touches[0]);
        //clickObject(event);
      }
    }, {passive: false});
    
    
    window.addEventListener('touchmove', (event) => {
      if(allLoaded==true&&isFocused==false)
      {
        setPickPosition(event.touches[0]);
      }
    });
    
    document.getElementById('c').addEventListener('touchmove', function (event) {
      if (isFocused && event.scale !== 1) { event.stopPropagation(); }
    }, false);

    document.getElementById('content').addEventListener('touchmove', function (event) {
      if (event.scale !== 1) { event.stopPropagation(); }
    }, false);

    var lastTouchEnd = 0;
    document.getElementById('content').addEventListener('touchend', function (event) {
      var now = (new Date()).getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    }, false);
/*
    window.addEventListener('touchend', clearPickPosition);
*/


    window.addEventListener('pointerdown', clickObject);
    //window.addEventListener('touchstart', clickObject);
    document.addEventListener('touchend', onDocumentTouchEnd, false);

    function onDocumentTouchEnd(event) {
      if(allLoaded==true&&isFocused==false)
      {
        if(preventDefault) event.preventDefault();

        mouse.x = (event.changedTouches[0].clientX / window.innerWidth) * 2 - 1;
        mouse.y = -(event.changedTouches[0].clientY / window.innerHeight) * 2 + 1;

      
        pickHelper.pick(pickPosition, scene, camera, selectableObjects, planetDestZ);
      }

    }

    window.addEventListener('wheel', (event) => {
      lastInteractionTime = performance.now();
      if(isScreenSaverMode && !isDebug)
      {
        exitScreenSaver();
      }
    });
  }

  
}

function clickObject( event ) {
  if(allLoaded==true&&isFocused==false)
  {
    pickHelper.pick(pickPosition, scene, camera, selectableObjects, planetDestZ);
  }
  lastInteractionTime = performance.now();
  if(isScreenSaverMode && !isDebug)
  {
    exitScreenSaver();
  }
  
  //console.log('clicked');
}

function getCanvasRelativePosition(event) {
  const rect = container.getBoundingClientRect();
  return {
    x: (event.clientX - rect.left) * container.width  / rect.width,
    y: (event.clientY - rect.top ) * container.height / rect.height,
  };
}
 
function setPickPosition(event) {
  let method = 2;

  if(method == 1)
  { 
    const pos = getCanvasRelativePosition(event);
    // pickPosition.x = pos.x;
    // pickPosition.y = pos.y;
    //console.log('pos : '+ pos.x+', '+pos.y);
    pickPosition.x = (pos.x / canvas.width ) *  2 - 1;
    pickPosition.y = (pos.y / canvas.height) * -2 + 1;
  }
  else
  {
    pickPosition.x = ( event.clientX / window.innerWidth ) * 2 - 1;
    pickPosition.y = - ( event.clientY / window.innerHeight ) * 2 + 1;
  }
  
  //console.log('mouse : '+ mouse.x+', '+mouse.y);

  if(useHoverScale)
  {
    pickHelper.move(pickPosition, scene, camera, selectableObjects, planetDestZ);
    // if(cursor && !isFocused)
    // {
    //   var vector = new THREE.Vector3( pickPosition.x, pickPosition.y, -1 ).unproject( camera );
    //   vector.sub( camera.position ).normalize();
    //   var distance = ( 0 - camera.position.z ) / vector.z;
    //   var pos = new THREE.Vector3();
    //   pos.copy( camera.position ).add( vector.multiplyScalar( distance ) );
    //   cursor.parent.position.x = pos.x;
    //   cursor.parent.position.y = pos.y;
    // }
    
  }

  lastInteractionTime = performance.now();
  if(isScreenSaverMode && !isDebug)
  {
    exitScreenSaver();
  }
}
 
function clearPickPosition() {
  // unlike the mouse which always has a position
  // if the user stops touching the screen we want
  // to stop picking. For now we just pick a value
  // unlikely to pick something
  pickPosition.x = -100000;
  pickPosition.y = -100000;
}

function onWindowResize() {
  console.log('Window is resized.')
 
  let windowAspect = window.innerWidth / window.innerHeight;
  camera.aspect = windowAspect;
  camera.updateProjectionMatrix();
  screenSaverCamera.aspect = windowAspect;
  screenSaverCamera.updateProjectionMatrix();

  renderer.setSize( window.innerWidth, window.innerHeight );
  labelRenderer.setSize( window.innerWidth, window.innerHeight );

  const canvasAspect = container.clientWidth / container.clientHeight;
  const imageAspect = bgTexture.image ? bgTexture.image.width / bgTexture.image.height : 1;
  const aspect = imageAspect / canvasAspect;

  /*
  if(canvasAspect>imageAspect)
  {
    backgroundImg.scale.x = backgroundScale / aspect;
  }
  */
  // bgTexture.offset.x = aspect > 1 ? (1 - 1 / aspect) / 2 : 0;
  // bgTexture.repeat.x = aspect > 1 ? 1 / aspect : 1;
 
  // bgTexture.offset.y = aspect > 1 ? 0 : (1 - aspect) / 2;
  // bgTexture.repeat.y = aspect > 1 ? 1 : aspect;

  if(window.innerHeight > window.innerWidth){
    beltOriginXInitial = beltOriginXInitialPortrait;
    beltOriginYInitial = beltOriginYInitialPortrait;
  }
  else
  {
    beltOriginXInitial = beltOriginXInitialLandscape;
    beltOriginYInitial = beltOriginYInitialLandscape;
  }
  beltOriginChanged = true;

  if(windowAspect < 0.7)
  {
    zoomSmaller = true;
  }
  else
  {
    zoomSmaller = false;
  }
  //render();
  
  resizeContent();
  //renderer.render( scene, camera );
}

function render(time) {

  if(showStats) stats.begin();

  time *= 0.001;  // convert time to seconds

  if(allLoaded)
  {
    controls.saveState();
    let screenOriginX = controls.position0.x;
    let screenOriginY = controls.position0.y;
    let screenOriginZOffset = controls.position0.z - 10;
    if(zoomSmaller) screenOriginZOffset -= 0.5;
    //console.log(screenOriginX+','+screenOriginY);

    /*
    if(focusStartObject && !focusStartObjectLoaded)
    {
      focusStartObjectLoaded = true;
      focusOn(focusStartObject);
    }
    */
    for(let i=1;i<=9;i++)
    {

      try {
        planets[i-1].rotation.y = planetRotation[i-1] * time * 0.5 + planetRotationOffset[i-1];
        planets[i-1].rotation.x = planetRotationXOffset;
        if(i==1 && planetRotationXOffset>Math.PI/2)
        {
          planets[i-1].rotation.x = Math.PI / 2;
        }
        
        planets[i-1].parent.position.x = planetOrbitX[i-1]*Math.cos(planetRevolution[i-1]*time+planetRevolutionOffset[i-1]);
        planets[i-1].parent.position.y = planetOrbitY[i-1]*Math.sin(planetRevolution[i-1]*time+planetRevolutionOffset[i-1]);

        var curScale = planets[i-1].originalScale;
        planets[i-1].scale.x = curScale;
        planets[i-1].scale.y = curScale;
        planets[i-1].scale.z = curScale;

      } catch (e) {
          if (e instanceof TypeError) {
              //printError(e, true);
              console.log('type error');
          } else {
              //printError(e, false);
              console.log(e);
          }
      }
    }
    {
      try {
        moon.rotation.y = moonRotation * time * 0.5 + moonRotationOffset;
        moon.rotation.x = planetRotationXOffset;
        
        moon.parent.position.x = planets[3].parent.position.x + (moonOrbitX*Math.cos(moonRevolution*time+moonRevolutionOffset));
        moon.parent.position.y = planets[3].parent.position.y + (moonOrbitY*Math.sin(moonRevolution*time+moonRevolutionOffset));

        var curScale = moon.originalScale;
        moon.scale.x = curScale;
        moon.scale.y = curScale;
        moon.scale.z = curScale;

      } catch (e) {
          if (e instanceof TypeError) {
              //printError(e, true);
              console.log('type error');
          } else {
              //printError(e, false);
              console.log(e);
          }
      }
    }
    for(let k=1;k<=2;k++)
    {
      try {
        marsMoon[k-1].rotation.y = marsMoonRotation[k-1] * time * 0.5 + marsMoonRotationOffset[k-1];
        marsMoon[k-1].rotation.x = planetRotationXOffset;
        
        marsMoon[k-1].parent.position.x = planets[4].parent.position.x + (marsMoonOrbitX*Math.cos(marsMoonRevolution*time+marsMoonRevolutionOffset[k-1]));
        marsMoon[k-1].parent.position.y = planets[4].parent.position.y + (marsMoonOrbitY*Math.sin(marsMoonRevolution*time+marsMoonRevolutionOffset[k-1]));

        var curScale =marsMoon[k-1].originalScale;
        marsMoon[k-1].scale.x = curScale;
        marsMoon[k-1].scale.y = curScale;
        marsMoon[k-1].scale.z = curScale;

      } catch (e) {
          if (e instanceof TypeError) {
              console.log('type error');
          } else {
              console.log(e);
          }
      }
    }
    for(let k=1;k<=4;k++)
    {
      try {
        jupiterMoon[k-1].rotation.y = jupiterMoonRotation[k-1] * time * 0.5 + jupiterMoonRotationOffset[k-1];
        jupiterMoon[k-1].rotation.x = planetRotationXOffset;
        
        jupiterMoon[k-1].parent.position.x = planets[5].parent.position.x + jupiterMoonOrbitX*Math.cos(jupiterMoonRevolution*time+jupiterMoonRevolutionOffset[k-1]);
        jupiterMoon[k-1].parent.position.y = planets[5].parent.position.y + jupiterMoonOrbitY*Math.sin(jupiterMoonRevolution*time+jupiterMoonRevolutionOffset[k-1]);

        var curScale =jupiterMoon[k-1].originalScale;
        jupiterMoon[k-1].scale.x = curScale;
        jupiterMoon[k-1].scale.y = curScale;
        jupiterMoon[k-1].scale.z = curScale;

      } catch (e) {
          if (e instanceof TypeError) {
              console.log('type error');
          } else {
              console.log(e);
          }
      }
    }
    for(let k=1;k<=7;k++)
    {
      try {
        saturnMoon[k-1].rotation.y = saturnMoonRotation[k-1] * time * 0.5 + saturnMoonRotationOffset[k-1];
        saturnMoon[k-1].rotation.x = planetRotationXOffset;
        
        saturnMoon[k-1].parent.position.x = planets[6].parent.position.x + saturnMoonOrbitX*Math.cos(saturnMoonRevolution*time+saturnMoonRevolutionOffset[k-1]);
        saturnMoon[k-1].parent.position.y = planets[6].parent.position.y + saturnMoonOrbitY*Math.sin(saturnMoonRevolution*time+saturnMoonRevolutionOffset[k-1]);

        var curScale =saturnMoon[k-1].originalScale;
        saturnMoon[k-1].scale.x = curScale;
        saturnMoon[k-1].scale.y = curScale;
        saturnMoon[k-1].scale.z = curScale;

      } catch (e) {
          if (e instanceof TypeError) {
              console.log('type error');
          } else {
              console.log(e);
          }
      }
    }
    for(let k=1;k<=3;k++)
    {
      try {
        belt[k-1].rotation.y = beltRotation[k-1] * time * 0.5 + beltRotationOffset[k-1];
        belt[k-1].rotation.x = planetRotationXOffset;
        
        belt[k-1].parent.position.x = beltOriginX + beltOrbitX*Math.cos(beltRevolution*time+beltRevolutionOffset[k-1]);
        belt[k-1].parent.position.y = beltOriginY + beltOrbitY*Math.sin(beltRevolution*time+beltRevolutionOffset[k-1]);

        var curScale =belt[k-1].originalScale;
        belt[k-1].scale.x = curScale;
        belt[k-1].scale.y = curScale;
        belt[k-1].scale.z = curScale;

      } catch (e) {
          if (e instanceof TypeError) {
              console.log('type error');
          } else {
              console.log(e);
          }
      }
    }

    if(beltOriginChanged)
    {
      beltOriginX = beltOriginXInitial;
      beltOriginY = beltOriginYInitial;
      beltOriginChanged = false;
    }

    {
      try {
        compass.rotation.y = compassRotationSpeed * time * 0.5;
        
        // compass.parent.position.x = planets[3].parent.position.x + (moonOrbitX*Math.cos(moonRevolution*time+moonRevolutionOffset));
        // compass.parent.position.y = planets[3].parent.position.y + (moonOrbitY*Math.sin(moonRevolution*time+moonRevolutionOffset));

        // var curScale = compass.originalScale;
        // compass.scale.x = curScale;
        // compass.scale.y = curScale;
        // compass.scale.z = curScale;

      } catch (e) {
          if (e instanceof TypeError) {
              //printError(e, true);
              console.log('type error');
          } else {
              //printError(e, false);
              console.log(e);
          }
      }
    }
    
    //lightMaterial.opacity = ((Math.sin(time*1.5) + 1.0) / 2.0) * 0.5 + 0.5; //sinusoidal
    let lightBrightness = flickerFunction(time);
    // lightMaterial.opacity = 0.5 + 0.5*lightBrightness; //flicker
    lightMaterial.opacity = lightBrightness; //flicker
    // if(sunObject)
    // {
    //   if(lightBrightness>0.25)
    //   {
    //     sunObject.opacity = 0.3;
    //     sunObject.emissive.r = lightBrightness *0.6;
    //     sunObject.emissive.g = lightBrightness *0.2;
    //     sunObject.emissive.b = 0;
    //   }
    //   else
    //   {
    //     sunObject.opacity = 0.2;
    //     sunObject.emissive.r = 0;
    //     sunObject.emissive.g = 0.15;
    //     sunObject.emissive.b = 0.4;
    //   }
    // }
    if(useLight) light.intensity = lightBrightness * lightIntensity;

    if(isFocused)
    {
      if(curFrame<destFrame)
      {
        //let sqt = Math.pow(curFrame/destFrame,2);
        //let coeff = sqt / (2.0 * (sqt - curFrame/destFrame) + 1.0);
        let coeff = -1 * Math.pow(curFrame/destFrame - 1.0,4) +1;
        //let coeff = Math.sin(Math.PI/2.0*curFrame/destFrame);
        //let coeff = Math.pow(Math.sin(Math.PI/2.0*curFrame/destFrame),2);
        if(!isProjectEncyclopedia)
        {
          if(focusedObject.isBelt == false)
          {
            let originX = focusedObject.orbitX*Math.cos(focusedObject.revolution*time+focusedObject.revolutionOffset);
            let originY = focusedObject.orbitY*Math.sin(focusedObject.revolution*time+focusedObject.revolutionOffset);
            if(focusedObject.isMoon)
            {
              originX += planets[focusedObject.planetIndex].parent.position.x;
              originY += planets[focusedObject.planetIndex].parent.position.y;
            }
            focusedObject.parent.position.x = coeff * (screenOriginX - originX) + originX;
            focusedObject.parent.position.y = coeff * (screenOriginY - originY) + originY;
            focusedObject.parent.position.z = coeff * (screenOriginZOffset + focusedObject.destZ - 0);
          }
          else
          {
            let beltCoeff = Math.pow(curFrame/destFrame - 1.0,3) +1;
            beltOriginX = beltCoeff * (screenOriginX - beltOriginXInitial) + beltOriginXInitial;
            beltOriginY = beltCoeff * (screenOriginY - beltOriginYInitial) + beltOriginYInitial;
            for(let k=0;k<3;k++)
            {
              belt[k].parent.position.z = beltCoeff * (screenOriginZOffset + beltDestZ - 0);
            }
          }
        }
        else if(contentNum === '0')
        {
          compass.parent.position.x = screenOriginX;
          compass.parent.position.y = screenOriginY;
          compass.parent.position.z = screenOriginZOffset + compass.destZ;

          compass.visible = true;
          // compass.children[0].material.opacity = coeff * (1.0 - 0.0) + 0.0;
          // setOpacityToObject(compass,coeff * (1.0 - 0.0) + 0.0);
        }
        
        document.getElementById ("project-encyclopedia-about").style.opacity = 1.7 * coeff * (projectEncyclopediaDisabledOpacity - 1.0) + 1.0;
        document.getElementById ("project-encyclopedia").style.opacity = 1.7 * coeff * (projectEncyclopediaDisabledOpacity - 1.0) + 1.0;
        document.getElementById ("content").style.opacity = coeff * (1.0 - 0.0) + 0.0;
        
        blackMaterial.opacity = coeff * (0.5 - 0.0);
        curFrame ++;
        inAnimation = true;
      }
      else
      {
        inAnimation = false;
        if(!isProjectEncyclopedia)
        {
          if(focusedObject.isBelt == false)
          {
            focusedObject.parent.position.x = screenOriginX;
            focusedObject.parent.position.y = screenOriginY;
            focusedObject.parent.position.z = screenOriginZOffset + focusedObject.destZ;
          }
          else
          {
            beltOriginX = screenOriginX;
            beltOriginY = screenOriginY;
            for(let k=0;k<3;k++)
            {
              belt[k].parent.position.z = screenOriginZOffset + beltDestZ;
            }
          }
        }
        else if(contentNum === '0')
        {
          compass.parent.position.x = screenOriginX;
          compass.parent.position.y = screenOriginY;
          compass.parent.position.z = screenOriginZOffset + compass.destZ;

          compass.visible = true;
          // compass.children[0].material.opacity = 1;
          // setOpacityToObject(compass,1);
        }
        
        blackMaterial.opacity = 0.5;
        document.getElementById ("project-encyclopedia-about").style.opacity = projectEncyclopediaDisabledOpacity;
        document.getElementById ("project-encyclopedia").style.opacity = projectEncyclopediaDisabledOpacity;
        document.getElementById ("content").style.opacity = 1.0;
      }

      if(useLight) light.intensity = 0;
    }
    else if(isHovered)
    {
      if(hoveredObject.isBelt == false)
      {
        var curScale = (hoverDestScale * hoveredObject.originalScale);
        hoveredObject.scale.x = curScale;
        hoveredObject.scale.y = curScale;
        hoveredObject.scale.z = curScale;
      }
      else
      {
        for(let k=0;k<3;k++)
        {
          var curScale = (hoverDestScale * belt[k].originalScale);
          belt[k].scale.x = curScale;
          belt[k].scale.y = curScale;
          belt[k].scale.z = curScale;
        }
      }
    }

    if(isScreenSaverMode)
    {
      let elapsedTime = time - screenSaverStartTime;
      // elapsedTime *=3;
      // console.log(elapsedTime)
      cameraRotationSpeed = 0.5;

      if(!readyForScreenSaver)
      {
        //Move to position
        let transitionTime = Math.PI * 2;
        hideScreenSaverContent();
        document.getElementById('screensaver-title').style.display='none';
        if(0 < elapsedTime && elapsedTime < transitionTime)
        {
          let startTime = 0;
          let endTime = transitionTime;
          let coeff = easeInOutSine((elapsedTime-startTime)/(endTime-startTime))
          screenSaverCameraDistance = (1-coeff)*startCameraDistance + coeff*10;
          centerOfRotation.lerpVectors(prevCenterOfRotation, targetCenterOfRotation, coeff);
          planetRotationXOffset = (1-coeff)*0 + coeff*((Math.PI / 180) * 100);

          // screenSaverCamera.position.set(centerOfRotation.x, centerOfRotation.y, screenSaverCameraDistance)

          let normalVec = screenSaverCamera.position.clone().sub(centerOfRotation).normalize();
          let adjacent = Math.sqrt((normalVec.x * normalVec.x) + (normalVec.y * normalVec.y));
          normalVec.z = Math.abs(Math.tan(screenSaverCameraAngle) * adjacent);
          normalVec.normalize();
          screenSaverCamera.position.set(centerOfRotation.x + normalVec.x * screenSaverCameraDistance, centerOfRotation.y + normalVec.y * screenSaverCameraDistance, centerOfRotation.z + normalVec.z * screenSaverCameraDistance)
          
          // Revolve around center
          let xyRadius = Math.sqrt(Math.pow(centerOfRotation.x - screenSaverCamera.position.x, 2) + Math.pow(centerOfRotation.y - screenSaverCamera.position.y, 2));
          screenSaverCamera.position.x = centerOfRotation.x + xyRadius * Math.cos(-Math.PI/2+(elapsedTime + screenSaverTimeOffset) * 0.5 * cameraRotationSpeed);
          screenSaverCamera.position.y = centerOfRotation.y + xyRadius * Math.sin(-Math.PI/2+(elapsedTime + screenSaverTimeOffset) * 0.5 * cameraRotationSpeed);
          console.log(-Math.PI/2+(elapsedTime + screenSaverTimeOffset) * 0.5 * cameraRotationSpeed)
          
          screenSaverCamera.lookAt(centerOfRotation);
        }
        else if(transitionTime <= elapsedTime)
        {
          planetRotationXOffset = (Math.PI / 180) * 100 ;
          centerOfRotation.set(0, 0, 0);
          prevCenterOfRotation.set(centerOfRotation.x, centerOfRotation.y, centerOfRotation.z);
          readyForScreenSaver = true;
          screenSaverStartTime = time;
        }
      }
      else
      {
        if(0 <= elapsedTime && elapsedTime <= 20)
        {
          // Move to earth
          let startTime = 0;
          let endTime = 20;
          let startAngle = Math.PI / 2 - 0.01;
          let endAngle = Math.PI / 6;
          let startDistance = 10;
          let endDistance = 1.2;
          targetCenterOfRotation.set(planets[3].parent.position.x, planets[3].parent.position.y, planets[3].parent.position.z + screenSaverTargetZOffset);
          let coeff = easeInOutCubic((elapsedTime-startTime)/(endTime-startTime))
          screenSaverCameraDistance = (1-coeff)*startDistance + coeff*endDistance;
          screenSaverCameraAngle = (1-coeff)*startAngle + coeff*endAngle;
          centerOfRotation.lerpVectors(prevCenterOfRotation, targetCenterOfRotation, coeff);
          // cameraRotationSpeed = (1-(elapsedTime-startTime)/(endTime-startTime))*0.0 + (elapsedTime-startTime)/(endTime-startTime)*0.5;
          // cameraRotationSpeed = (1-coeff)*0.0 + coeff*0.5;
  
          //content - earth
          hideScreenSaverContent();
          document.getElementById('screensaver-title').style.display='none';
          document.getElementById('screensaver-title').innerHTML = 'Planet 72.82m²'
          document.getElementById('screensaver-info-4').style.display='block'
          document.getElementById('screensaver-reference-4').style.display='block';
          document.getElementById('screensaver-image-4').style.display='block';
          document.getElementById('screensaver-text-4').style.display='block';
        }
        else if(20 < elapsedTime && elapsedTime <= 40)
        {
          // Focus at earth
          centerOfRotation.set(planets[3].parent.position.x, planets[3].parent.position.y, planets[3].parent.position.z + screenSaverTargetZOffset);
          prevCenterOfRotation.set(centerOfRotation.x, centerOfRotation.y, centerOfRotation.z);
  
          //content display
          document.getElementById('screensaver-title').style.display='block';
          document.getElementById('screensaver-info-4').style.visibility='visible'
          let referenceStartTime = 22;
          let referenceEndTime = 38;
          if(referenceStartTime < elapsedTime && elapsedTime <= referenceEndTime)
          {
            let referenceCoeff = (elapsedTime-referenceStartTime)/(referenceEndTime-referenceStartTime);
            document.getElementById('screensaver-reference').style.top = (window.innerHeight+5) * referenceCoeff - (document.getElementById('screensaver-reference-4').clientHeight+20) * (1-referenceCoeff) + 'px'
            // 4160 / 16 = 260
          }
          else if(referenceEndTime < elapsedTime)
          {
            document.getElementById('screensaver-reference-4').style.display='none'
          }
          let imageStartTime = 21;
          let imageEndTime = 37;
          if(imageStartTime < elapsedTime && elapsedTime <= imageEndTime)
          {
            let imageCoeff = (elapsedTime-imageStartTime)/(imageEndTime-imageStartTime);
            document.getElementById('screensaver-image').style.left = (window.innerWidth+5) * (1-imageCoeff) - (document.getElementById('screensaver-image-4').clientWidth+20) * imageCoeff + 'px'
            // 5125 / 16 = 320.3125
          }
          else if(imageEndTime < elapsedTime)
          {
            document.getElementById('screensaver-image-4').style.display='none'
          }
          let textStartTime = 23;
          let textEndTime = 39;
          if(textStartTime < elapsedTime && elapsedTime <= textEndTime)
          {
            let textCoeff = (elapsedTime-textStartTime)/(textEndTime-textStartTime);
            document.getElementById('screensaver-text').style.top = (window.innerHeight+5) * (1-textCoeff) - (document.getElementById('screensaver-text-4').clientHeight+20) * textCoeff + 'px'
          }
          else if(textEndTime < elapsedTime)
          {
            document.getElementById('screensaver-text-4').style.display='none'
          }
        }
        else if(40 < elapsedTime && elapsedTime <= 50)
        {
          // Move to belt
          let startTime = 40;
          let endTime = 50;
          let startDistance = 1.2;
          let midDistance = 5;
          let endDistance = 1.7;
          targetCenterOfRotation.set(beltOriginX, beltOriginY, screenSaverTargetZOffset - 0.02);
          let coeff = easeInOutCubic((elapsedTime-startTime)/(endTime-startTime))
          screenSaverCameraDistance = coeff <= 0.5 ? (midDistance - startDistance) * Math.sin(Math.PI * coeff) + startDistance : (midDistance - endDistance) * Math.sin(Math.PI * coeff) + endDistance;
          centerOfRotation.lerpVectors(prevCenterOfRotation, targetCenterOfRotation, coeff);
  
          //content - belt
          hideScreenSaverContent();
          document.getElementById('screensaver-title').style.display='none';
          document.getElementById('screensaver-title').innerHTML = 'About Ground Water Light and Air'
          document.getElementById('screensaver-info-10').style.display='block'
          document.getElementById('screensaver-reference-10').style.display='block';
          document.getElementById('screensaver-image-10').style.display='block';
          document.getElementById('screensaver-text-10').style.display='block';
        }
        else if(50 < elapsedTime && elapsedTime <= 70)
        {
          // Focus at belt
          centerOfRotation.set(beltOriginX, beltOriginY, screenSaverTargetZOffset - 0.02);
          prevCenterOfRotation.set(centerOfRotation.x, centerOfRotation.y, centerOfRotation.z);
  
          //content display
          document.getElementById('screensaver-title').style.display='block';
          document.getElementById('screensaver-info-10').style.visibility='visible'
          let referenceStartTime = 52;
          let referenceEndTime = 68;
          if(referenceStartTime < elapsedTime && elapsedTime <= referenceEndTime)
          {
            let referenceCoeff = (elapsedTime-referenceStartTime)/(referenceEndTime-referenceStartTime);
            document.getElementById('screensaver-reference').style.top = (window.innerHeight+5) * referenceCoeff - (document.getElementById('screensaver-reference-10').clientHeight+20) * (1-referenceCoeff) + 'px'
          }
          else if(referenceEndTime < elapsedTime)
          {
            document.getElementById('screensaver-reference-10').style.display='none'
          }
          let imageStartTime = 51;
          let imageEndTime = 67;
          if(imageStartTime < elapsedTime && elapsedTime <= imageEndTime)
          {
            let imageCoeff = (elapsedTime-imageStartTime)/(imageEndTime-imageStartTime);
            document.getElementById('screensaver-image').style.left = (window.innerWidth+5) * (1-imageCoeff) - (document.getElementById('screensaver-image-10').clientWidth+20) * imageCoeff + 'px'
          }
          else if(imageEndTime < elapsedTime)
          {
            document.getElementById('screensaver-image-10').style.display='none'
          }
          let textStartTime = 53;
          let textEndTime = 69;
          if(textStartTime < elapsedTime && elapsedTime <= textEndTime)
          {
            let textCoeff = (elapsedTime-textStartTime)/(textEndTime-textStartTime);
            document.getElementById('screensaver-text').style.top = (window.innerHeight+5) * (1-textCoeff) - (document.getElementById('screensaver-text-10').clientHeight+20) * textCoeff + 'px'
          }
          else if(textEndTime < elapsedTime)
          {
            document.getElementById('screensaver-text-10').style.display='none'
          }
        }
        else if(70 < elapsedTime && elapsedTime <= 80)
        {
          // Move to mercury
          let startTime = 70;
          let endTime = 80;
          let startDistance = 1.7;
          let midDistance = 5;
          let endDistance = 0.8;
          targetCenterOfRotation.set(planets[1].parent.position.x, planets[1].parent.position.y, planets[1].parent.position.z + screenSaverTargetZOffset);
          let coeff = easeInOutCubic((elapsedTime-startTime)/(endTime-startTime))
          screenSaverCameraDistance = coeff <= 0.5 ? (midDistance - startDistance) * Math.sin(Math.PI * coeff) + startDistance : (midDistance - endDistance) * Math.sin(Math.PI * coeff) + endDistance;
          centerOfRotation.lerpVectors(prevCenterOfRotation, targetCenterOfRotation, coeff);
  
          //content - mercury
          hideScreenSaverContent();
          document.getElementById('screensaver-title').style.display='none';
          document.getElementById('screensaver-title').innerHTML = 'Mercury Play Back'
          document.getElementById('screensaver-info-2').style.display='block'
          document.getElementById('screensaver-reference-2').style.display='block';
          document.getElementById('screensaver-image-2').style.display='block';
          document.getElementById('screensaver-text-2').style.display='block';
        }
        else if(80 < elapsedTime && elapsedTime <= 100)
        {
          // Focus at mercury
          centerOfRotation.set(planets[1].parent.position.x, planets[1].parent.position.y, planets[1].parent.position.z + screenSaverTargetZOffset);
          prevCenterOfRotation.set(centerOfRotation.x, centerOfRotation.y, centerOfRotation.z);
  
          //content display
          document.getElementById('screensaver-title').style.display='block';
          document.getElementById('screensaver-info-2').style.visibility='visible'
          let referenceStartTime = 82;
          let referenceEndTime = 98;
          if(referenceStartTime < elapsedTime && elapsedTime <= referenceEndTime)
          {
            let referenceCoeff = (elapsedTime-referenceStartTime)/(referenceEndTime-referenceStartTime);
            document.getElementById('screensaver-reference').style.top = (window.innerHeight+5) * referenceCoeff - (document.getElementById('screensaver-reference-2').clientHeight+20) * (1-referenceCoeff) + 'px'
          }
          else if(referenceEndTime < elapsedTime)
          {
            document.getElementById('screensaver-reference-2').style.display='none'
          }
          let imageStartTime = 81;
          let imageEndTime = 97;
          if(imageStartTime < elapsedTime && elapsedTime <= imageEndTime)
          {
            let imageCoeff = (elapsedTime-imageStartTime)/(imageEndTime-imageStartTime);
            document.getElementById('screensaver-image').style.left = (window.innerWidth+5) * (1-imageCoeff) - (document.getElementById('screensaver-image-2').clientWidth+20) * imageCoeff + 'px'
          }
          else if(imageEndTime < elapsedTime)
          {
            document.getElementById('screensaver-image-2').style.display='none'
          }
          let textStartTime = 83;
          let textEndTime = 99;
          if(textStartTime < elapsedTime && elapsedTime <= textEndTime)
          {
            let textCoeff = (elapsedTime-textStartTime)/(textEndTime-textStartTime);
            document.getElementById('screensaver-text').style.top = (window.innerHeight+5) * (1-textCoeff) - (document.getElementById('screensaver-text-2').clientHeight+20) * textCoeff + 'px'
          }
          else if(textEndTime < elapsedTime)
          {
            document.getElementById('screensaver-text-2').style.display='none'
          }
        }
        else if(100 < elapsedTime && elapsedTime <= 110)
        {
          // Move to sun
          let startTime = 100;
          let endTime = 110;
          let startDistance = 0.8;
          let midDistance = 3.5;
          let endDistance = 1.3;
          targetCenterOfRotation.set(planets[0].parent.position.x, planets[0].parent.position.y, planets[0].parent.position.z + screenSaverTargetZOffset);
          let coeff = easeInOutCubic((elapsedTime-startTime)/(endTime-startTime))
          screenSaverCameraDistance = coeff <= 0.5 ? (midDistance - startDistance) * Math.sin(Math.PI * coeff) + startDistance : (midDistance - endDistance) * Math.sin(Math.PI * coeff) + endDistance;
          centerOfRotation.lerpVectors(prevCenterOfRotation, targetCenterOfRotation, coeff);
  
          //content - sun
          hideScreenSaverContent();
          document.getElementById('screensaver-title').style.display='none';
          document.getElementById('screensaver-title').innerHTML = 'eureka'
          document.getElementById('screensaver-info-1').style.display='block'
          document.getElementById('screensaver-reference-1').style.display='block';
          document.getElementById('screensaver-image-1').style.display='block';
          document.getElementById('screensaver-text-1').style.display='block';
        }
        else if(110 < elapsedTime && elapsedTime <= 130)
        {
          // Focus at sun
          centerOfRotation.set(planets[0].parent.position.x, planets[0].parent.position.y, planets[0].parent.position.z + screenSaverTargetZOffset);
          prevCenterOfRotation.set(centerOfRotation.x, centerOfRotation.y, centerOfRotation.z);
  
          //content display
          document.getElementById('screensaver-title').style.display='block';
          document.getElementById('screensaver-info-1').style.visibility='visible'
          let referenceStartTime = 112;
          let referenceEndTime = 128;
          if(referenceStartTime < elapsedTime && elapsedTime <= referenceEndTime)
          {
            let referenceCoeff = (elapsedTime-referenceStartTime)/(referenceEndTime-referenceStartTime);
            document.getElementById('screensaver-reference').style.top = (window.innerHeight+5) * referenceCoeff - (document.getElementById('screensaver-reference-1').clientHeight+20) * (1-referenceCoeff) + 'px'
          }
          else if(referenceEndTime < elapsedTime)
          {
            document.getElementById('screensaver-reference-1').style.display='none'
          }
          let imageStartTime = 111;
          let imageEndTime = 127;
          if(imageStartTime < elapsedTime && elapsedTime <= imageEndTime)
          {
            let imageCoeff = (elapsedTime-imageStartTime)/(imageEndTime-imageStartTime);
            document.getElementById('screensaver-image').style.left = (window.innerWidth+5) * (1-imageCoeff) - (document.getElementById('screensaver-image-1').clientWidth+20) * imageCoeff + 'px'
          }
          else if(imageEndTime < elapsedTime)
          {
            document.getElementById('screensaver-image-1').style.display='none'
          }
          let textStartTime = 113;
          let textEndTime = 129;
          if(textStartTime < elapsedTime && elapsedTime <= textEndTime)
          {
            let textCoeff = (elapsedTime-textStartTime)/(textEndTime-textStartTime);
            document.getElementById('screensaver-text').style.top = (window.innerHeight+5) * (1-textCoeff) - (document.getElementById('screensaver-text-1').clientHeight+20) * textCoeff + 'px'
          }
          else if(textEndTime < elapsedTime)
          {
            document.getElementById('screensaver-text-1').style.display='none'
          }
        }
        else if(130 < elapsedTime && elapsedTime <= 140)
        {
          // Move out
          let startTime = 130;
          let endTime = 140;
          let startAngle = Math.PI / 6;
          let endAngle = Math.PI / 2 - 0.01;
          let startDistance = 1.3;
          let endDistance = 10;
          targetCenterOfRotation.set(planets[0].parent.position.x, planets[0].parent.position.y, planets[0].parent.position.z + screenSaverTargetZOffset);
          let coeff = easeInOutCubic((elapsedTime-startTime)/(endTime-startTime))
          screenSaverCameraDistance = (1-coeff)*startDistance + coeff*endDistance;
          screenSaverCameraAngle = (1-coeff)*startAngle + coeff*endAngle;
          centerOfRotation.lerpVectors(prevCenterOfRotation, targetCenterOfRotation, coeff);
  
          //content - mercury
          hideScreenSaverContent();
          document.getElementById('screensaver-title').style.display='none';
        }
        else if(140 < elapsedTime)
        {
          screenSaverCameraAngle = Math.PI / 2 - 0.01;
          centerOfRotation.set(planets[0].parent.position.x, planets[0].parent.position.y, planets[0].parent.position.z);
          prevCenterOfRotation.set(planets[0].parent.position.x, planets[0].parent.position.y, planets[0].parent.position.z);
          screenSaverCameraDistance = 10;
          screenSaverStartTime = time;
        }
  
        
  
        // Set distance and angle
        let normalVec = screenSaverCamera.position.clone().sub(centerOfRotation).normalize();
        let adjacent = Math.sqrt((normalVec.x * normalVec.x) + (normalVec.y * normalVec.y));
        normalVec.z = Math.abs(Math.tan(screenSaverCameraAngle) * adjacent);
        normalVec.normalize();
        screenSaverCamera.position.set(centerOfRotation.x + normalVec.x * screenSaverCameraDistance, centerOfRotation.y + normalVec.y * screenSaverCameraDistance, centerOfRotation.z + normalVec.z * screenSaverCameraDistance)
        
        // Revolve around center
        let xyRadius = Math.sqrt(Math.pow(centerOfRotation.x - screenSaverCamera.position.x, 2) + Math.pow(centerOfRotation.y - screenSaverCamera.position.y, 2));
        screenSaverCamera.position.x = centerOfRotation.x + xyRadius * Math.cos((elapsedTime + screenSaverTimeOffset) * 0.5 * cameraRotationSpeed);
        screenSaverCamera.position.y = centerOfRotation.y + xyRadius * Math.sin((elapsedTime + screenSaverTimeOffset) * 0.5 * cameraRotationSpeed);
        console.log(-Math.PI/2+(elapsedTime + screenSaverTimeOffset) * 0.5 * cameraRotationSpeed)
        
        screenSaverCamera.lookAt(centerOfRotation);
        // screenSaverCamera.updateProjectionMatrix();
  
        if(140 < elapsedTime)
        {
          screenSaverTimeOffset = (((elapsedTime + screenSaverTimeOffset) * 0.5 * cameraRotationSpeed)%(2*Math.PI)) / 0.5 / cameraRotationSpeed;
        }
      }

      if(isDebug)
        {
          debugCurrentSphere.position.set(centerOfRotation.x, centerOfRotation.y, centerOfRotation.z)
          debugStartSphere.position.set(prevCenterOfRotation.x, prevCenterOfRotation.y, prevCenterOfRotation.z)
          debugTargetSphere.position.set(targetCenterOfRotation.x, targetCenterOfRotation.y, targetCenterOfRotation.z)
        }

    }
    else
    {
      screenSaverStartTime = time;
    }
    
    renderer.render( scene, currentRenderCamera );
    if(!isScreenSaverMode)
    {
      labelRenderer.render(scene, camera);
      if(!isMobile)
      {
        if(!document.hasFocus() || showingWorksVideo) lastInteractionTime = performance.now();
        // console.log(performance.now())
        let timeWaited = performance.now()-lastInteractionTime;
        // console.log(timeWaited)
        if(timeWaited > screenSaverWaitTime )
        {
          console.log("Start screen saver");
          enterScreenSaver()
        }
      }
    }
  }
  //document.getElementById('c').scrollTo(0,0);
  if(showStats) stats.end();

  if(!limitFramerate)
  {
    requestAnimationFrame(render);
  }
  else
  {
    setTimeout( function() {

        requestAnimationFrame( render );

    }, 1000 / framerate );
  }
  
  
}
requestAnimationFrame(render);

function checkLoadedObjects(){
  loadingValue += 1;
  $('#load-progress').attr('aria-valuenow', ((loadingValue / totalObjects)*100).toFixed(0)).css('width', ((loadingValue / totalObjects)*100).toString()+'%');
  if(loadingValue == totalObjects)
  {
    console.log('All Objects Loaded');
    allLoaded = true;
    var element = document.querySelector('#loading'); 
    element.style.visibility = 'hidden'; 
    element.style.display = 'none'; 
    document.getElementById('project-encyclopedia').style.display = 'block';
    document.getElementById('project-encyclopedia-about').style.display = 'block';
    if(isDebug)
    {
      document.getElementById('debug-controls').style.display = 'block';
    }
  }
}


var waveFunction = "sqr2"; // possible values: sin, tri(angle), sqr(square), saw(tooth), inv(verted sawtooth), noise (random)
var base = 0.5; // start
var amplitude = 0.5; // amplitude of the wave
var phase = 0.0; // start point inside on wave cycle
var frequency = 0.5; // cycle frequency per second

function flickerFunction (time) {
  var x  = (time + phase)*frequency;
  var y;
  let a = (time * 1000)%(1000*Math.random());
 
  x = x - Math.floor(x); // normalized value (0..1)
 
  if (waveFunction=="sin") {
    y = Math.sin(x*2*Math.PI);
  }
  else if (waveFunction=="tri") {
    if (x < 0.5)
      y = 4.0 * x - 1.0;
    else
      y = -4.0 * x + 3.0;  
  }    
  else if (waveFunction=="sqr") {
    if (x < 0.5)
      y = 1.0;
    else
      y = -1.0;  
  }    
  else if (waveFunction=="saw") {
      y = x;
  }    
  else if (waveFunction=="inv") {
    y = 1.0 - x;
  }    
  else if (waveFunction=="noise") {
    y = 1 - (Math.random()*2);
  }
  else if (waveFunction=="sinnoise") {
    y = 1 - (Math.random()*2*Math.sin(x*2*Math.PI));
  }
  else {
    y = 1.0;
  }        
  if(a<17)
  return (y*amplitude)+base;     
  else return ((Math.sin(time*1.5) + 1.0) / 2.0) * 0.35 + 0.6;
}

//https://easings.net/
function easeInOutCubic(x) {
  return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
}
function easeInOutSine(x) {
  return -(Math.cos(Math.PI * x) - 1) / 2;
}
function easeOutCubic(x) {
  return 1 - Math.pow(1 - x, 3);
}
function easeInSine(x) {
  return 1 - Math.cos((x * Math.PI) / 2);
}
function easeOutSine(x) {
  return Math.sin((x * Math.PI) / 2);
}
function easeInCubic(x) {
  return x * x * x;
}


/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */
/*--------------------------------------------------------------------------------------------------------------------------------------------------------- */


document.getElementById ("pills-home-tab").addEventListener ("click", hideHomeTab, false);
document.getElementById ("pills-info-tab").addEventListener ("click", showHomeTab, false);
document.getElementById ("pills-image-tab").addEventListener ("click", showHomeTab, false);
// document.getElementById ("pills-video-tab").addEventListener ("click", showHomeTab, false);
document.getElementById ("pills-text-tab").addEventListener ("click", showHomeTab, false);
document.getElementById ("pills-reference-tab").addEventListener ("click", showHomeTab, false);
document.getElementById ("go-back").addEventListener ("click", goBack, false);
document.getElementById ("project-encyclopedia-text").addEventListener ("pointerdown", openAbout, false);
document.getElementById ("project-encyclopedia").addEventListener ("pointerdown", openProjectEncyclopedia, false);
document.getElementById ("galleria-close-button").addEventListener ("click", closeGalleria, false);
window.addEventListener("keydown", (event) => {
  if(event.key === "Escape") {
    closeGalleria();
  }
  // do something
});

function showHomeTab(){
  if((isProjectEncyclopedia && contentNum === 'about')||(focusedObject&&!focusedObject.isExhibition)) return false;
  document.getElementById('go-back').style.display = 'none';
  document.getElementById('pills-home-tab').style.display = 'block';
  return false;
}

function hideHomeTab(){
  document.getElementById('go-back').style.display = 'block';
  document.getElementById('pills-home-tab').style.display = 'none';
  isInMenu = false;
  isModal = false;
  return false;
}

function closeGalleria(){
  $('.galleria-container').remove();
  $('#imageModal').modal('hide');
  document.getElementById ("galleria-close-button").style.display='none'
  if(soundOn && mainthemeaudio.paused)
  {
    mainthemeaudio.play();
  }
  showingWorksVideo = false;
}

function goBack(){
  isFocused = false;
  isInMenu = false;

  $('#pills-tab a[href="#pills-home"]').tab('show');
  
  if(!isProjectEncyclopedia)
  {
    focusedObject.parent.position.z = 0;
    if(focusedObject.isBelt)
    {
      beltOriginX = beltOriginXInitial;
      beltOriginY = beltOriginYInitial;
      for(let k=0;k<3;k++)
      {
        belt[k].parent.position.z = 0;
      }
    }
  }
  else if(contentNum === '0')
  {
    compass.visible = false;
  }
  
  blackMaterial.opacity = 0.0;
  document.getElementById ("project-encyclopedia-about").style.opacity = 1.0;
  document.getElementById ("project-encyclopedia").style.opacity = 1.0;
  document.getElementById ("content").style.opacity = 0.0;

  setExhibitionLabelOpacity(1.0);
  
  focusedObject = undefined;
  curFrame = 0;

  for(let k=0;k<scene.children.length;k++)
  {
    scene.children.opacity = 1.0;
  }
  $('#content').css('display', 'none');
  //$('#c').css('pointer-events', 'auto');
  document.getElementById('c').getElementsByTagName('canvas')[0].style.pointerEvents = 'auto';
  isProjectEncyclopedia = false;

  $('#reference-component').empty();

  if(audio)
  {
    audio.pause();
  }
  showingWorksVideo = false;
  mainthemeaudio.volume = 1;
  if(soundOn && mainthemeaudio.paused)
  {
    mainthemeaudio.play();
  }

  return false;
}

function setExhibitionLabelOpacity(inOpacity)
{
  document.getElementById ("exhibition-label-1").style.opacity = inOpacity;
  document.getElementById ("exhibition-label-2").style.opacity = inOpacity;
  document.getElementById ("exhibition-label-4").style.opacity = inOpacity;
  document.getElementById ("exhibition-label-10").style.opacity = inOpacity;
}



function showExhibition(){

  /* -----------------------------------TAB---------------------------------------------  */

  // INDEX
  if(contentNum === 'about')
  {
    document.getElementById ("pills-index-tab").style.display = 'block';
  }
  else
  {
    document.getElementById ("pills-index-tab").style.display = 'none';
  }

  // INFO
  if(contentNum === '0' || contentNum === '1' || contentNum === '2' || contentNum === '4' || contentNum === '10')
    document.getElementById ("pills-info-tab").style.display = 'block';
  else
    document.getElementById ("pills-info-tab").style.display = 'none';
  
  // IMAGE
  if(contentNum === '0' || contentNum === '1' || contentNum === '2' || contentNum === '4' || contentNum === '10')
    document.getElementById ("pills-image-tab").style.display = 'block';
  else
    document.getElementById ("pills-image-tab").style.display = 'none';
  
  if(contentNum === '0' || contentNum === '1' || contentNum === '2' || contentNum === '4' || contentNum === '10' || contentNum === 'about') // contentNum === '1'
  {
    document.getElementById ("pills-text-tab").style.display = 'block';
    document.getElementById('text-go-up').style.display = 'block';
    if(contentNum === 'about')
    {
      // document.getElementById('pills-text-tab').innerHTML = 'About';
      document.getElementById('pills-text-tab').innerHTML = '<span class="white-box">About</span>';
    }
    else
    {
      // document.getElementById('pills-text-tab').innerHTML = 'Text';
      document.getElementById('pills-text-tab').innerHTML = '<span class="white-box">Text</span>';
    }
  }
  else
  document.getElementById ("pills-text-tab").style.display = 'none';
    


  /* -----------------------------------CONTENT DISABLE---------------------------------------------  */
  // DISABLE ALL
  existingContents.forEach(function(value){

    document.getElementById ("info-"+value).style.display = 'none';
    
    document.getElementById ("image-"+value).style.display = 'none';

    document.getElementById ("text-"+value).style.display = 'none';
  });

  /* -----------------------------------CONTENT SHOW---------------------------------------------  */
  // SHOW IF AVAILABLE

  // INFO
  if(contentNum === '0' || contentNum === '1' || contentNum === '2' || contentNum === '4' || contentNum === '10')
  {
    //document.getElementById('info-content').innerHTML = '';
    //$("#info-content").load("info-"+contentNum+".html"); 
    document.getElementById ("info-"+contentNum).style.display = 'block';
  }
    
  
  // IMAGE
  if(contentNum === '0' || contentNum === '1' || contentNum === '2' || contentNum === '4' || contentNum === '10')
  {
    document.getElementById('image-'+contentNum).innerHTML = '';
    //$('#image-'+contentNum).load("image/image-"+contentNum+".html"); 
    document.getElementById ("image-"+contentNum).style.display = 'block';

    
    //TODO:
    $('#imageModalBody').load("image/image-"+contentNum+".html", function() {
      // console.log('loaded');
      // console.log(contentNum);
    }); 

  }

  // TEXT
  if(contentNum === '0' || contentNum === '1' || contentNum === '2' || contentNum === '4' || contentNum === '10' || contentNum === 'about')
  {
    document.getElementById('text-'+contentNum).innerHTML = '';
    $('#text-'+contentNum).load("text/text-"+contentNum+".html"); 
    document.getElementById ("text-"+contentNum).style.display = 'block';
  }
    

  return false;
  /* --------------------------------------------------------------------------------  */
}

function hideExhibition(){
  document.getElementById ("pills-index-tab").style.display = 'none';
  document.getElementById ("pills-info-tab").style.display = 'none';
  document.getElementById ("pills-image-tab").style.display = 'none';
  document.getElementById ("pills-text-tab").style.display = 'none';
  return false;
}



function showContent(){

  setExhibitionLabelOpacity(0.0);
  if(focusedObject)
  {
    document.getElementById ("pills-reference-tab").style.display = 'block';
    document.getElementById ("pills-image-tab").style.display = 'block';
    
    let title = '';
    if(focusedObject.name === "Sun")
    {
      title = 'eureka';
      contentNum = '1';
      audio = soundList[1]
      if(soundOn)
      {
        audio.currentTime = 0;
        audio.play();
      }
      mainthemeaudio.pause();
      mainthemeaudio.volume = 0.3;
    }
    if(focusedObject.name === "Mercury")
    {
      title = 'Mercury Play Back';
      contentNum = '2';
      audio = soundList[2]
      if(soundOn)
      {
        audio.currentTime = 0;
        audio.play();
      }
      mainthemeaudio.pause();
      mainthemeaudio.volume = 0.3;
    }
    if(focusedObject.name === "Earth")
    {
      title = 'Planet 72.82m²';
      contentNum = '4';
      audio = soundList[4]
      if(soundOn)
      {
        audio.currentTime = 0;
        audio.play();
      }
      mainthemeaudio.pause();
      mainthemeaudio.volume = 0.3;
    }
    else if(focusedObject.name === "Kuiper Belt")
    {
      title = 'About Ground Water Light and Air';
      contentNum = '10';
      audio = soundList[10]
      if(soundOn)
      {
        audio.currentTime = 0;
        audio.play();
      }
      mainthemeaudio.pause();
      mainthemeaudio.volume = 0.3;
    }
    else
    {
      //title = focusedObject.name;
    }

    // SHOW TITLE AT BOTTOM
    document.getElementById('pills-home').innerHTML = '<span class="object-title noselect">'+title+'</span>';
    $('#pills-tab a[href="#pills-home"]').tab('show');

    document.getElementById('project-encyclopedia-about-title').style.display='none'


    if(focusedObject.isExhibition)
    {
      document.getElementById ("pills-info-tab").style.display = 'block';
      //document.getElementById('pills-reference-tab').innerHTML = 'Reference';
      showExhibition();

      //to reduce loading time
      $('#reference-component').load("referencehtml/reference-"+contentNum+".html"); 
    }
    else
    {
      audio = soundList[20]
      if(soundOn)
      {
        audio.currentTime = 0;
        audio.play();
      }
      mainthemeaudio.pause();
      mainthemeaudio.volume = 0.3;
      //document.getElementById('pills-reference-tab').innerHTML = 'Images';
      hideExhibition();
      //showHomeTab();
      $('#pills-tab a[href="#pills-reference"]').tab('show');

      // document.getElementById('reference-component').innerHTML = '<div id="ref-spinner-'+focusedObject.directoryName+'" class="ref-spinner"><div class="spinner-border text-light" role="status"></div></div>';
      document.getElementById('reference-component').innerHTML = "";
      for(let i=1;i<=focusedObject.numOfReferences;i++)
      {
        // let prefix = focusedObject.referencePrefix;
        // if(prefix.length>0) prefix += '-';
        let imgfilename = 'reference/'+focusedObject.directoryName+'/'+i.toString();
        let imgfileext = '.jpg'
        document.getElementById('reference-component').innerHTML += '<img loading="lazy" class="ref-img noselect" src="'+imgfilename+imgfileext+'"></img>';
      }

      // console.log(document.getElementById('reference-component').innerHTML)
      // var image = new Image();
      // image.addEventListener("load", function() {
      //   //console.log('loadedloaded img');
      //   if(focusedObject) $('#ref-spinner-'+focusedObject.directoryName).css('display','none');
      // }, false);
      // let prefix = focusedObject.referencePrefix;
      // if(prefix.length>0) prefix += '-';
      // image.src = 'reference/'+focusedObject.directoryName+'/'+prefix+'1.jpg';
    }
  }
  else if(isProjectEncyclopedia && contentNum === '0') //navigator selected
  {
    document.getElementById ("pills-reference-tab").style.display = 'none';
    document.getElementById ("pills-info-tab").style.display = 'none';
    document.getElementById ("pills-image-tab").style.display = 'block';
    document.getElementById('project-encyclopedia-about-title').style.display='none'

    // SHOW TITLE AT BOTTOM
    let title = 'Encyclopedia'
    document.getElementById('pills-home').innerHTML = '<span class="object-title noselect">'+title+'</span>';
    $('#pills-tab a[href="#pills-home"]').tab('show');

    // $('#pills-tab a[href="#pills-info"]').tab('show');
    showExhibition();

    audio = soundList[0]
    if(soundOn)
    {
      audio.currentTime = 0;
      audio.play();
    }
    mainthemeaudio.pause();
    mainthemeaudio.volume = 0.3;
  }
  else if(isProjectEncyclopedia && contentNum === 'about') //about selected
  {
    document.getElementById ("pills-reference-tab").style.display = 'none';
    document.getElementById ("pills-info-tab").style.display = 'none';
    document.getElementById ("pills-image-tab").style.display = 'none';
    document.getElementById('project-encyclopedia-about-title').style.display='flex';
    $('#pills-tab a[href="#pills-index"]').tab('show');
    showExhibition();

    audio = soundList[30]
    if(soundOn)
    {
      audio.currentTime = 0;
      audio.play();
    }
    mainthemeaudio.pause();
    mainthemeaudio.volume = 0.3;
  }

  $('#content').css('display', 'inline');
  
  resizeContent();

  pushCurrentState();
}

function openProjectEncyclopedia(){
 
  document.getElementById('c').getElementsByTagName('canvas')[0].style.pointerEvents = 'none';
  isFocused = true;
  contentNum = '0'
  isProjectEncyclopedia = true;
  showContent();
  
}

function openAbout(){
 
  document.getElementById('c').getElementsByTagName('canvas')[0].style.pointerEvents = 'none';
  isFocused = true;
  contentNum = 'about'
  isProjectEncyclopedia = true;
  showContent();
  
}

function resizeContent(){
  document.getElementById('c').style.height = window.innerHeight;
  document.getElementById('content').style.height = window.innerHeight;
  //document.getElementById('content-row').style.height = window.innerHeight -(document.getElementById('pills-tab').getBoundingClientRect().bottom + document.getElementById('pills-tab').getBoundingClientRect().top);
  document.getElementById('text-component').style.height = window.innerHeight - (document.getElementById('pills-tab').getBoundingClientRect().bottom + document.getElementById('pills-tab').getBoundingClientRect().top)-3;
  document.getElementById('reference-component').style.height = window.innerHeight - (document.getElementById('pills-tab').getBoundingClientRect().bottom + document.getElementById('pills-tab').getBoundingClientRect().top)-3;
  document.getElementById('info-component').style.height = window.innerHeight - (document.getElementById('pills-tab').getBoundingClientRect().bottom + document.getElementById('pills-tab').getBoundingClientRect().top)-3;
  document.getElementById('image-component').style.height = window.innerHeight - (document.getElementById('pills-tab').getBoundingClientRect().bottom + document.getElementById('pills-tab').getBoundingClientRect().top)-3;
  document.getElementById('index-component').style.height = window.innerHeight - (document.getElementById('pills-tab').getBoundingClientRect().bottom + document.getElementById('pills-tab').getBoundingClientRect().top)-3;

  let ratio = 1.78;
  let tabHeight = 0;
  let padding = 20;
  let textHeight = 50;
  if(document.getElementById('imageModalBody').getElementsByClassName('nav-pills').length) tabHeight = 40;
  let width = (window.innerHeight-tabHeight-padding) * ratio;
  if(window.innerWidth > width) document.getElementById('imageModalBody').style.width = width;
  else document.getElementById('imageModalBody').style.width = window.innerWidth +'px';

  
  let height = (window.innerWidth / 1.78) + tabHeight + padding + textHeight;
  if(window.innerHeight > height) document.getElementById('imageModalContent').style.height = height;
  else document.getElementById('imageModalContent').style.height =  window.innerHeight +'px';
  
}


// WHEN MENU TAB CLICKED MOVE UP
$('#pills-tab a[href="#pills-reference"]').on('shown.bs.tab', function (e) {
  document.getElementById('reference-component').scrollTo(0,0);
  //document.getElementById('content-row').style.setProperty("overflow-y", "hidden");
});

$('#pills-tab a[href="#pills-text"]').on('shown.bs.tab', function (e) {
  document.getElementById('text-component').scrollTo(0,0);
  //document.getElementById('content-row').style.setProperty("overflow-y", "hidden");
});

$('#pills-tab a[href="#pills-index"]').on('shown.bs.tab', function (e) {
  document.getElementById('index-component').scrollTo(0,0);
  //document.getElementById('content-row').style.setProperty("overflow-y", "hidden");
});

$('#pills-tab a[href="#pills-image"]').on('shown.bs.tab', function (e) {
  //document.getElementById('content-row').style.setProperty("overflow-y", "auto", "important");
  //document.getElementById('image-component').style.height = window.innerHeight - (document.getElementById('pills-tab').getBoundingClientRect().bottom + document.getElementById('pills-tab').getBoundingClientRect().top)-3;

  //width / height= 1.78
  let ratio = 1.78;
  //ratio = document.getElementById('imageModalBody').offsetWidth / document.getElementById('imageModalBody').offsetHeight;
  let tabHeight = 0;
  let padding = 20;
  let textHeight = 50;
  if(document.getElementById('imageModalBody').getElementsByClassName('nav-pills').length) tabHeight = 40;
  let width = (window.innerHeight-tabHeight - padding) * ratio;
  if(window.innerWidth > width) document.getElementById('imageModalBody').style.width = width;
  else document.getElementById('imageModalBody').style.width = window.innerWidth+'px';

  
  let height = (window.innerWidth / 1.78) + tabHeight + padding + textHeight;
  if(window.innerHeight > height) document.getElementById('imageModalContent').style.height = height;
  else document.getElementById('imageModalContent').style.height = window.innerHeight + 'px';
  
  //TODO
  $('#imageModal').modal('show');

  Galleria.configure({
    debug: false // debug is now off for deployment
  });
  Galleria.loadTheme('assets/galleria.classic.js'); //fullscreen, classic, azur, twelve, miniml, folio
  Galleria.run('.galleria', {
    imageCrop: false,
    debug: false,
    clicknext: true,
    smallarrows: true,
    _hideDock: true,
    swipe: 'auto',  // disabled, enforced
    // classic: Set this to false if you want the caption to show always
    _toggleInfo: false,
    dataConfig: function(img) {
      // img is now the image element
      // the function should return an object with the new data
      return {
          title: $(img).attr('rel'), // sets title to "John Doe"
          description: $(img).parent().next('.img-desc').html() // sets description to "My picture"
      };
    }
  });
  document.getElementById ("galleria-close-button").style.display='block';
});


$('#imageModal').on('hide.bs.modal', function (e) {

  // if(contentNum === '0')
  // {
  //   $('#pills-tab a[href="#pills-info"]').tab('show');
  // }
  // else
  {
    $('#pills-tab a[href="#pills-home"]').tab('show');
    hideHomeTab();
  }
  
});

$('#pills-tab a[href="#pills-info"]').on('shown.bs.tab', function (e) {
  if(contentNum === '10')
  {
    document.getElementById('info-10').currentTime = 0;
    document.getElementById('info-10').play();
  }
  if(contentNum === '2')
  {
    document.getElementById('info-2').currentTime = 0;
    document.getElementById('info-2').play();
  }
  //document.getElementById('content-row').style.setProperty("overflow-y", "auto", "important");
  document.getElementById('info-component').style.height = window.innerHeight - (document.getElementById('pills-tab').getBoundingClientRect().bottom + document.getElementById('pills-tab').getBoundingClientRect().top)-3;
});



history.pushState({
  isFocused: isFocused
}, webTitle);

function pushCurrentState()
{
  history.replaceState({
    isFocused: isFocused
  }, webTitle);
}
 
window.addEventListener('popstate', e=>{
  history.go(1);
  {
    closeGalleria();
    goBack();
  }

})


const inputHandler = function(e) {
  indexSearchValue = e.target.value.toLocaleLowerCase();
  refreshIndexContent();
}

document.getElementById('index-input').addEventListener('input', inputHandler);

function refreshIndexContent()
{
  var currentSearchCategory = '';
  if(indexSearchValue.length>0)
  {
    for(let [category, element] of Object.entries(indexCategoryMap))
    {
      element.style.display='none';
    }
    for(let indexNum = 0; indexNum < numberOfIndices; indexNum++)
    {
      if(indexCsv[indexNum].lowercasename.includes(indexSearchValue))
      {
        if(indexCsv[indexNum].category != currentSearchCategory)
        {
          currentSearchCategory = indexCsv[indexNum].category;
          indexCategoryMap[currentSearchCategory].style.display='block';
        }
        indexCsv[indexNum].textElement.style.display='block';
        indexCsv[indexNum].imageElement.style.display='block';
      }
      else
      {
        indexCsv[indexNum].textElement.style.display='none';
        indexCsv[indexNum].imageElement.style.display='none';
      }
    }
  }
  else
  {
    for(let [category, element] of Object.entries(indexCategoryMap))
    {
      element.style.display='block';
    }
    for(let indexNum = 0; indexNum < numberOfIndices; indexNum++)
    {
      indexCsv[indexNum].textElement.style.display='block';
      indexCsv[indexNum].imageElement.style.display='none';
    }
  }
}
refreshIndexContent();

document.getElementById('project-encyclopedia-about').addEventListener('mouseenter',function(){
  document.getElementById('project-encyclopedia-about').style.transform = 'scale(1.1)';
})

document.getElementById('project-encyclopedia-about').addEventListener('mouseleave',function(){
  document.getElementById('project-encyclopedia-about').style.transform = 'scale(1.0)';
})

document.getElementById('project-encyclopedia').addEventListener('mouseenter',function(){
  document.getElementById('project-encyclopedia').style.transform = 'scale(1.3)';
})

document.getElementById('project-encyclopedia').addEventListener('mouseleave',function(){
  document.getElementById('project-encyclopedia').style.transform = 'scale(1.0)';
})

if(isDebug)
{
  // document.getElementById('debug-controls').style.display = 'block';
  document.getElementById('screen-saver-btn').addEventListener('click', toggleScreenSaver);

  screenSaverWaitTime = 10 * 1000;
}

function toggleScreenSaver(){
  if(!isScreenSaverMode)
  {
    enterScreenSaver()
  }
  else
  {
    exitScreenSaver()
  }
}

function enterScreenSaver(){
  if(isMobile) return;
  if(isFocused)
  {
    closeGalleria();
    goBack();
  }

  // screenSaverCamera.position.set(camPosX, camPosY+1, camPosZ);
  screenSaverCamera.rotation.set(0,0,0);
  screenSaverCamera.updateProjectionMatrix();
  // screenSaverCamera.near = 0.01;
  // screenSaverCamera.far = 100;

  hideScreenSaverContent();
  
  currentRenderCamera = screenSaverCamera;
  startCameraDistance = camera.position.z;//centerOfRotation.distanceTo(screenSaverCamera.position)
  screenSaverCameraAngle = Math.PI / 2 -0.01;
  centerOfRotation.set(0, 0, 0);
  // prevCenterOfRotation.set(centerOfRotation.x, centerOfRotation.y, centerOfRotation.z);
  prevCenterOfRotation.set(camera.position.x, camera.position.y, 0);
  targetCenterOfRotation.set(0, 0, 0);
  isScreenSaverMode = true;
  controls.enabled = false;
  planetRotationXOffset = 0;
  screenSaverTimeOffset = 0;
  planets[0].parent.position.z = 0.05;
  readyForScreenSaver = false;

  document.getElementById('project-encyclopedia-about').style.display='none';
  document.getElementById('project-encyclopedia').style.display='none';
  setExhibitionLabelOpacity(0.0);
  

  document.getElementById('screensaver-content').style.display='block'

  if(isDebug)
  {
    let isVisible = false;
    debugCurrentSphere.visible = isVisible;
    debugStartSphere.visible = isVisible;
    debugTargetSphere.visible = isVisible;
  }
}

function exitScreenSaver(){
  currentRenderCamera = camera;
  isScreenSaverMode = false;
  controls.enabled = true;
  planetRotationXOffset = 0;
  planets[0].parent.position.z = 0;

  document.getElementById('project-encyclopedia-about').style.display='block';
  document.getElementById('project-encyclopedia').style.display='block';
  setExhibitionLabelOpacity(1.0);

  document.getElementById('screensaver-content').style.display='none'
  hideScreenSaverContent();

  if(isDebug)
  {
    debugCurrentSphere.visible = false;
    debugStartSphere.visible = false;
    debugTargetSphere.visible = false;
  }
}

document.getElementById('screensaver-content').style.display='none'
hideScreenSaverContent();

function hideScreenSaverContent(){
  document.getElementById('screensaver-info-1').style.visibility='hidden'
  document.getElementById('screensaver-info-2').style.visibility='hidden'
  document.getElementById('screensaver-info-4').style.visibility='hidden'
  document.getElementById('screensaver-info-10').style.visibility='hidden'

  document.getElementById('screensaver-info-1').style.display='none'
  document.getElementById('screensaver-info-2').style.display='none'
  document.getElementById('screensaver-info-4').style.display='none'
  document.getElementById('screensaver-info-10').style.display='none'

  document.getElementById('screensaver-text').style.top = '300%'
  document.getElementById('screensaver-text-1').style.display='none'
  document.getElementById('screensaver-text-2').style.display='none'
  document.getElementById('screensaver-text-4').style.display='none'
  document.getElementById('screensaver-text-10').style.display='none'

  document.getElementById('screensaver-reference').style.top = '105%'
  document.getElementById('screensaver-reference-1').style.display='none';
  document.getElementById('screensaver-reference-2').style.display='none';
  document.getElementById('screensaver-reference-4').style.display='none';
  document.getElementById('screensaver-reference-10').style.display='none';

  document.getElementById('screensaver-image').style.left = '105%'
  document.getElementById('screensaver-image-1').style.display='none';
  document.getElementById('screensaver-image-2').style.display='none';
  document.getElementById('screensaver-image-4').style.display='none';
  document.getElementById('screensaver-image-10').style.display='none';
}

$('#screensaver-text-1').load("screensaver-text/text-1.html"); 
$('#screensaver-text-2').load("screensaver-text/text-2.html"); 
$('#screensaver-text-4').load("screensaver-text/text-4.html"); 
$('#screensaver-text-10').load("screensaver-text/text-10.html"); 

Galleria.on('image', function(e) {
  // console.log('image loaded ' + e.index)
  // Galleria.log(this); // the gallery scope
  // Galleria.log(e.galleriaData );
  // Galleria.log(e.imageTarget); // the currently active IMG element
  // Galleria.log(e.thumbTarget);
  if(e.galleriaData.iframe)
  {
    // console.log('playable')
    showingWorksVideo = true;
    if(soundOn && !mainthemeaudio.paused)
    {
      mainthemeaudio.pause();
    }
    document.getElementsByClassName('galleria-images')[0].style.zIndex = '1';
  }
  else
  {
    // console.log('nonplayable')
    showingWorksVideo = false;
    if(soundOn && mainthemeaudio.paused)
    {
      mainthemeaudio.play();
    }
    document.getElementsByClassName('galleria-images')[0].style.zIndex = '';
  }
});

window.addEventListener('focus', (event) => {
  console.log('has focus')
  lastInteractionTime = performance.now();
});